import { Injectable } from '@angular/core';
import { CommonService } from '../_service/common.service';
import { appConfig, baseUrl } from '../app.config';
import { map } from 'rxjs/operators';
import { Observable, of, Subject } from "rxjs";
import { PagerService } from '../_service/pager-service';
import { NotificationService } from '../_service/notification.service';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { CountryService } from '../_service/country.service';
import { SitesService } from '../_service/sites.service';
import { SupplierService } from '../_service/supplier.service';
import { purchasingApiService } from '../_service/purchasing.service';
import { AddressService } from '../_service/address.service';

const TWO = 2;
const THREE = 3;
const FOUR = 4;
const FIVE = 5;
const SIX = 6;
const SEVEN = 7;
const EIGHT = 8;
const TEN = 10;
const TWENTY = 20;
const THIRTY_SECONDS_MS = 30000;
const ONE_SECOND_MS = 1000;
const THREE_THOUSAND_MS = 3000;
const TWO_THOUSAND_MS = 2000;
const SIXTY = 60;
const PAD_OFFSET = -2;
const NINE = 9;
const THIRTY_FIVE = 35;
const ONE_HUNDRED_SEVEN = 107;
const HTTP_STATUS_BAD_REQUEST = 400;
const RETRIABLE_SERVER_ERROR_PATTERN = /\bError\s+(500|502|503|504|401)\b/;

@Injectable({
  providedIn: 'root'
})
export class ImportbvdService {

  Config: any;
  public maxRecorePage = TWENTY;
  data: any = [];
  loadData = false;
  loading = false;
  loadingImpsupp = false;
  retry = 0;
  public PageTotalLength: any = "";
  pager: any = {};
  public CaptCountry: any = [];
  public CountryNameKeyId: any = [];
  public selectedCountry: any = "failed";
  public CaptCity: any = [];
  public CityNameKeyId: any = [];
  public selectedCity: any = "failed";
  public CaptCountryForTaxId: any = [];
  public siteCountryModelForTaxId = '';


  Qualifiers: {
    "P14": "assets/sites/icons/P14.png",
    "P18": "assets/sites/icons/P18.png",
  }
  companyNameModel: any = ""
  public siteCountryModel: any = "";
  public siteCityModel: any = "";
  companyNameModelError = false;
  public siteCountryModelError = false;
  cityDisable = true;
  importNextButt: any = "Next";
  BvDnumber: any;
  BvDbySplitNumber: any;
  BvDdata: any = [];
  importSuppStep2 = false;
  importSuppStep3 = false;
  addStep2Check = false;
  public groupCategories: any = [];
  groupCategoriesByKey: any = [];
  public groupCategoryModel: any = '';
  public groupCategoryModelError = false;
  public groupCommodityCodeModelLabel = '';
  public groupNameModelError = false;
  public groupMdmSwitch = false;
  userQuestionUpdate3 = new Subject<string>();
  tempvar: any = '';
  commodityCodeScopeRowid: any = '';
  arrCommoditycodes = false;
  public groupCommodityCodeModel: any = '';
  GroupBvDdetails: any = [];
  GroupSelectDisab = false;
  typeName = '';
  public companyStatusRowid: any = '';
  public companyRowId: any = '';
  public mainTaxRowid: any = '';
  public IdenKeywithId: any = [];
  public CIdentifierTypes: any = [];
  companyInfos: any = [];
  companyList: any = [];

  sveCompanies: any = "";

  SitesInfo: any = [];
  SiteRowID: any = "";
  Site_hrefTo_Cid: any = [];
  beRowID: any = [];
  site_qualifiers: any = [];
  SiteDispLoading = true;
  SiteDe_BvdID_Stat: any = [];
  Site_City_Country: any = [];

  public cpyAlcorToRaft = [];
  public cpyRowIdHolder = '';
  public siteCity: any = '';
  public arrBasedOnVal = [];
  public sitesData = [];
  public qualifierChangetoPending = ['P11', 'P05', 'P06', 'P19', 'P07', 'P09', 'P08'];

  public qualifierTypesText = {
    P05: "Manufacturing",
    P06: "Invoicing",
    P07: "Picking",
    P08: "Customer",
    P09: "Quality Return",
    P11: "Ordering",
    P14: "Main Entrance",
    P18: "Headquarters",
    P19: "Supply Chain EDI"
  };

  public sortedQualifiers = {
    "P14": "assets/sites/icons/P14.png",
    "P18": "assets/sites/icons/P18.png",
    "P11": "assets/sites/icons/P11.png",
    "P05": "assets/sites/icons/P05.png",
    "P19": "assets/sites/icons/P19.png",
    "P07": "assets/sites/icons/P07.png",
    "P09": "assets/sites/icons/P09.png",
    "P06": "assets/sites/icons/P06.png",
    "P08": "assets/sites/icons/P08.png",

    "P100": ""
  };

  public groupNameModel = '';
  saveDatas: any = "Save";
  public alphabetsArray = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
  public digitsArray = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];



  public envHide: any = "";


  BE_Check = false;
  ImportDone = false;
  DisableSearch = false;
  NL_BVD_ID_NUMBER: any = "";
  NL_HQ_BVD_ID_NUMBER: any = "";
  NL_GUO_BVD_ID_NUMBER: any = "";
  NL_SaveGrp_ID: any = "";
  NL_Case_Occur: any = "";
  public newCategoryAssignment = '6'; //for categoryCode = B06;
  public newCategoryName = 'SUPPLIER SITE' //for category name
  loadingImpsupp2 = false;
  loadCompanySection = false;

  guoBvdCheck = false;
  hqBvdCheck = false;
  europeanVatNums: any = [];
  checkEVatNumerrorCount = 0;
  checkForStopOrContinue = false;

  public groupShortNameError = false;
  public groupShortNameRegExError = false;
  public groupShortNameExistsError = false;
  public groupShortName: any = '';
  GroupAssign: any;
  public accessPointIdenRowIds = [];
  NL_BvDdataCnS: any = [];
  NL_GUO_BvDdata: any = []; // Store GUO BVD data separately to prevent overwrite
  BEIDval: any = [];

  NL_flagGroup = false;
  NL_flagCompany = false;
  NL_flagSite = false;
  loadingImpsupp3 = false;
  loadSiteSection = false;

  NL_flagGroup_step1Init = false;
  NL_flagCompany_step2Init = false;
  NL_flagSite_step3Init = false;
  IdentifierModel: any = '';
  selectedCustomCountry = '';
  countrySelList = [];
  tempVarCounList = {};
  varIsMergingSite = '2';
  disableGrpShortNameLoad: boolean;
  groupIdHolder = '';
  selectedIdentifierType = '';
  public superUserShow = false;
  public selectedIdentifierError = false;
  roleVariableHide: boolean;
  showCountrySelectForTaxId = false;
  siteCountryModelErrorForIdens: boolean;
  disableIdentifierInput = true;
  countryCityList: any = [];
  latestCompanyId = '';
  groupCurrentStatus = 'loading...';
  roleIsManager: boolean;
  showBuyerProfile: boolean;
  disableNext = true;
  nextBtnNotVisible = false;
  pageHeight = 0;
  public dataForDispCountryInfo = [];
  countryInfoLoading = false;
  TaxIdentifierKeys: any[] = [];
  companyAliasAll: any = [];
  companyIdenKeys: any = [];
  public businessEntityIdSite = '';
  NullCheck = false;
  countryLoad1: boolean;
  countryLoad2: boolean;
  companyAllianceIdentifier: any;
  grpDisp = false;
  CompanySelectDisab = true;
  c2bName: any='';
  c2bValue = true;
  accessPointDatas3: any
  accessPointDatas1: any
  displayC2b: boolean;
  nodisplay = true;
  C2bDisplay = true;
  c2bError: boolean;
  loadingC2b: boolean;
  cmpDetails=[];
  cmpShortName = '';
  siteDisableNext = true;
  baseUrl2=baseUrl;
  key: string = 'name'; //set default
  reverse = false;
  currentOrbisStatus: any;
  noreload = false;
  BvdtoImport: any;
  bvdSearch: boolean;
  createdSite=[];
  createdSiteBvdIds: Set<string> = new Set();
  createdCompanyBvdIds: Set<string> = new Set();
  createdGroupBvdIds: Set<string> = new Set();
  financeType2: string = '';
  isImportInProgress: boolean = false;  // Lock to prevent race conditions between imports
  importStartTime: number = 0;  // Timestamp when import started (for timeout detection)
  private onConditionSatisfiedCallback: (() => void) | null = null;
  private onConditionSatisfiedCallback2: (() => void) | null = null;
  groupLinkError = ''
  private processingIndex: number | null = null;
  currentBvdIdImporting: number;
  cpyShortNameTypes = [];
  Error502 = false;

  constructor(private apiService: CommonService, private addressService: AddressService,private purchasingService: purchasingApiService, private countryService: CountryService,private siteService: SitesService,private supplierService:SupplierService,private pagerService: PagerService, private notificationService: NotificationService, private http: HttpClient, private router: Router) { 
    this.Config = appConfig;

    if (this.apiService && (this.apiService as any).administrationReset$) {
      (this.apiService as any).administrationReset$.subscribe((message) => {
        try {
          this.nullify(message);
        } catch (e) {
          console.info('Error during administration reset nullify:', e);
        }
      });
    }
  }
    /**
     * Set the callback function to be called when BE_Check==true || ImportDone==true
     * @param callback Function to call when condition is satisfied
     */
  setOnConditionSatisfiedCallback(callback: () => void): void {
      this.onConditionSatisfiedCallback = callback;
    }

    /**
     * Set the callback function to be called when BE_Check==true || ImportDone==true
     * @param callback Function to call when condition is satisfied
     */
  setOnConditionSatisfiedCallback2(callback: () => void): void {
      this.onConditionSatisfiedCallback2 = callback;
    }

    /**
     * Check if the condition BE_Check==true || ImportDone==true is satisfied
     * and call the callback if it is
     */
    private checkConditionAndNotify(): void {
      console.info(`[checkConditionAndNotify] Called. NL_Case_Occur=${this.NL_Case_Occur}, NL_flagCompany=${this.NL_flagCompany}, NL_flagCompany_step2Init=${this.NL_flagCompany_step2Init}, NL_flagSite_step3Init=${this.NL_flagSite_step3Init}, hasCallback=${!!this.onConditionSatisfiedCallback}`);
      
      if(this.NL_Case_Occur == 1){
        if ((this.NL_flagCompany === false && this.NL_flagCompany_step2Init === false && this.NL_flagSite_step3Init === true) && this.onConditionSatisfiedCallback) {
          console.info('[checkConditionAndNotify] Case 1 condition satisfied - releasing lock');
          this.processingIndex = null;
          this.isImportInProgress = false;  // Release import lock
          this.importStartTime = 0;  // Reset start time
          this.onConditionSatisfiedCallback();
          return;  // Exit after calling callback to prevent double-trigger
        }
      }
      if ((this.NL_flagCompany === true && this.NL_flagCompany_step2Init === true && this.NL_flagSite_step3Init === true) && this.onConditionSatisfiedCallback) {
        console.info('BvD Import condition satisfied: BE_Check=', this.NL_flagCompany, 'ImportDone=', this.ImportDone);
        this.processingIndex = null;
        this.isImportInProgress = false;  // Release import lock
        this.importStartTime = 0;  // Reset start time
        this.onConditionSatisfiedCallback();
        return;  // Exit after calling callback to prevent double-trigger
      }
      console.info('[checkConditionAndNotify] Conditions NOT met - lock NOT released');
    }

    private checkConditionAndNotify2(): void {
      console.info('[checkConditionAndNotify2] Called - releasing lock');
      this.processingIndex = null;
      this.isImportInProgress = false;  // Release import lock
      this.importStartTime = 0;  // Reset start time
      if (this.onConditionSatisfiedCallback2) {
        this.onConditionSatisfiedCallback2();
      }
    }

  detailsFetch(bvdData){
      let NDA = [];
        let ARL = [];
      bvdData.forEach((element: any) => {

          console.info('ele',element);
          if (element.MATCH) {
            if (typeof NDA[element.MATCH['SCORE']] == 'undefined') {
              NDA[element.MATCH['SCORE']] = [];
              ARL.push(element.MATCH['SCORE']);
            }
            NDA[element.MATCH['SCORE']].push(element);
          } else {
            if (element.MATCH == undefined) {
              element.MATCH = [];
            }
            if (element.MATCH == undefined) {
              element.MATCH = [];
            }
            if (element.MATCH['SCORE'] == undefined) {
              element.MATCH['SCORE'] = [];
            }
            element.MATCH['SCORE'] = 1;
            if (typeof NDA[element.MATCH['SCORE']] == 'undefined') {
              NDA[element.MATCH['SCORE']] = [];
              ARL.push(element.MATCH['SCORE']);
            }
            NDA[element.MATCH['SCORE']].push(element);
          }


        });
        ARL.sort(function (a, b) { return b - a }).forEach((element: any) => {
          NDA[element].forEach(element2 => {
            this.data=element2
          });
        });
        this.BvDnumber=`${this.data.BVD_ID_NUMBER}###${this.data.GUO_BVD_ID_NUMBER}###${this.data.HQ_BVD_ID_NUMBER}###${this.data.GUO_NAME}###${this.data.NAME}###${this.data.COUNTRY}###${this.data.CITY}###${this.data.POSTCODE}###${this.data.CITY_STANDARDIZED}`;
    }
    CheckImportSupplierNew() {
      const now = Date.now();
      console.info('CurrentImportingIndex', this.processingIndex, 'currentBvdIdImporting', this.currentBvdIdImporting);
      console.info('START IMPORT at', now);
      if (this.processingIndex === this.currentBvdIdImporting) {
    console.info('Already processing index', this.currentBvdIdImporting);
    return;
  }
  // CRITICAL FIX: Wait if another import is still in progress to prevent race conditions
  if (this.isImportInProgress) {
    // Safety mechanism: If import has been in progress for more than 30 seconds, force release the lock
    const importDuration = now - this.importStartTime;
    const MAX_IMPORT_DURATION = THIRTY_SECONDS_MS; // 30 seconds in milliseconds
    
    if (this.importStartTime > 0 && importDuration > MAX_IMPORT_DURATION) {
      console.error(`[IMPORT TIMEOUT] Import has been stuck for ${Math.round(importDuration / ONE_SECOND_MS)}s. Force releasing lock and proceeding...`);
      console.error(`[IMPORT TIMEOUT] Flags state: NL_Case_Occur=${this.NL_Case_Occur}, NL_flagCompany=${this.NL_flagCompany}, NL_flagCompany_step2Init=${this.NL_flagCompany_step2Init}, NL_flagSite_step3Init=${this.NL_flagSite_step3Init}`);
      this.isImportInProgress = false;
      this.processingIndex = null;
      // Don't return - continue with the new import
    } else {
      console.info(`[RACE CONDITION PREVENTION] Another import is in progress, waiting... (started ${Math.round(importDuration / ONE_SECOND_MS)}s ago)`);
      setTimeout(() => {
        this.CheckImportSupplierNew();
      }, ONE_SECOND_MS);
      return;
    }
  }
  // Set import lock and start timestamp
  this.isImportInProgress = true;
  this.importStartTime = now;
  this.processingIndex = this.currentBvdIdImporting;  // Track which import is being processed
    this.NL_SaveGrp_ID = "";
    this.loadingImpsupp = false;
    console.info("BvD 0-7", this.BvDnumber);
    this.checkForStopOrContinue=false;
    this.BvDdata = "";
    this.BvDdata = [];
    this.NL_BvDdataCnS = "";  // Reset NL_BvDdataCnS to prevent stale data
    this.NL_BvDdataCnS = [];  // Reset NL_BvDdataCnS array
    this.NL_GUO_BvDdata = ""; // Reset GUO BVD data to prevent stale data
    this.NL_GUO_BvDdata = []; // Reset GUO BVD data array
    this.siteDisableNext=true;
    this.companyInfos = "";
    this.companyInfos = [];
    this.GroupSelectDisab = false;
    this.groupCategoryModel = "";
    this.GroupBvDdetails = "";
    this.GroupBvDdetails = [];
    this.groupCommodityCodeModelLabel = "";
    this.BvDbySplitNumber = "";
    this.CompanySelectDisab = true;
    this.createdSite = []
    this.createdSiteBvdIds.clear(); // Reset site tracking for new import
    this.createdCompanyBvdIds.clear();
    this.createdGroupBvdIds.clear();
    this.retry = 0
    this.SitesInfo = "";
    this.SitesInfo = [];
    this.beRowID = "";
    this.beRowID = [];
    this.companyList = "";
    this.companyList = [];
    this.companyInfos = "";
    this.companyInfos = [];
    this.NL_Case_Occur = "";

    this.NL_flagGroup = false;
    this.NL_flagCompany = false;
    this.NL_flagSite = false;

    this.NL_flagGroup_step1Init = false;
    this.NL_flagCompany_step2Init = false;
    this.NL_flagSite_step3Init = false;
    
    this.noreload = false;  // Reset noreload flag to prevent skipping BVD interface calls
    this.cmpShortName = '';  // Reset company short name for new import
    this.companyRowId = '';  // CRITICAL: Reset companyRowId to prevent linking to wrong company
    this.BEIDval = '';  // CRITICAL: Reset BEIDval array to prevent stale data
    this.BEIDval = [];  // CRITICAL: Reset BEIDval array

    this.importSuppStep2 = false;
    this.importSuppStep3 = false;
    this.loadingImpsupp2 = false;
    this.loadingImpsupp3 = false;
    this.loadSiteSection = false;
    this.selectedCustomCountry = '';
    this.groupIdHolder = '';
    this.C2bDisplay=true;
    this.c2bName=''

    this.updateCreateGroupExistsName();
    if (this.BvDnumber != "") {


      var BvDAssign = this.BvDnumber.split("###");
      if (BvDAssign[0].includes(",")) {
        let variable = BvDAssign[0].split(",");
        BvDAssign[0] = variable[0];
      }
      if (BvDAssign[1].includes(",")) {
        let variable = BvDAssign[1].split(",");
        BvDAssign[1] = variable[0];
      }
      if (BvDAssign[2].includes(",")) {
        let variable = BvDAssign[2].split(",");
        BvDAssign[2] = variable[0];
      }
      this.sveCompanies = BvDAssign;


      this.BE_Check = false;
      this.guoBvdCheck = false;
      this.hqBvdCheck = false;
      this.NullCheck = false;
      this.ImportDone = false;
      this.NL_BVD_ID_NUMBER = BvDAssign[0];
      this.NL_HQ_BVD_ID_NUMBER = BvDAssign[2];
      this.NL_GUO_BVD_ID_NUMBER = BvDAssign[1];
      if (BvDAssign[2] == '' || BvDAssign[2] == 'null') {
        this.NL_HQ_BVD_ID_NUMBER = BvDAssign[0];
        BvDAssign[2] = BvDAssign[0];
      }
      if (BvDAssign[1] == '' || BvDAssign[1] == 'null') {
        this.NL_GUO_BVD_ID_NUMBER = BvDAssign[2];
        BvDAssign[1] = BvDAssign[2];
      }

      if (BvDAssign[0] != 'undefined' && BvDAssign[0] != 'null' && BvDAssign[0] != '') {  // if(1) BVD_ID_NUMBER is not null then.
        this.NullCheck = false;
        let type = null;

        this.europeanVatNums = [];
        for (let i = 0; i < THREE; i++) {
          if (i != 0 && BvDAssign[i] != 'undefined' && BvDAssign[i] != 'null' && BvDAssign[i] != '') {
            this.BvDdata = "";
            this.BvDdata = [];
            const datas1 = { "bvd-id": BvDAssign[i] , "import": "Y"}
            this.supplierService.createBvdInterface(`${this.Config.ApiSupplierUrl}bvd-interface`, datas1).subscribe((data: any) => {
              var bVdDatas = JSON.parse(data.result);
              this.BvdtoImport = bVdDatas;
              if (bVdDatas['Data'][0] != undefined && bVdDatas['Data'][0] != null) {
                this.BvDdata = bVdDatas['Data'][0];

              }
              if (i == 1) {
                type = 'GUO';
              } else if (i == TWO) {
                type = 'HQ';
              }
              console.info(`BvDdata ${BvDAssign[i]} ${type}`, this.BvDdata);
              console.info("this.BvDdata['NATIONAL_ID']", this.BvDdata['NATIONAL_ID'])
              console.info("this.BvDdata['NATIONAL_ID_LABEL']", this.BvDdata['NATIONAL_ID_LABEL'])
              if (this.BvDdata['NATIONAL_ID'] && this.BvDdata['NATIONAL_ID'].length > 0 && this.BvDdata['NATIONAL_ID'] != '') {
                var x = 0;
                this.BvDdata['NATIONAL_ID'].forEach(element => {
                  if (this.BvDdata['NATIONAL_ID_LABEL'][x] != null && element != null) {
                    console.info("CMT", this.BvDdata['NATIONAL_ID_LABEL'][x].toLowerCase());
                    if (this.BvDdata['NATIONAL_ID_LABEL'][x].toLowerCase() == 'european vat number') {
                      element = element.substring(0, TWENTY);
                      let temp = element.replace(" ", "");
                      let eurVatNumObj = {
                        'Evat': element.replace(" ", ""),
                        'bvd-id': BvDAssign[i],
                        'TypeBvd-id': type,
                        'index': i
                      }
                    }
                  }
                  x++;
                });
              }
            });
          }
        }
        const sorted = this.europeanVatNums.sort((a, b) => (a['index'] - b['index']))
        console.info("this.europeanVatNums", this.europeanVatNums);
        setTimeout(() => {
          this.stepsToImport(BvDAssign[0], BvDAssign[1], BvDAssign[2]);
        }, ONE_SECOND_MS);
      } else {
        this.NullCheck = true;
        console.info("Connot import the supplier due to null value of BVD_ID_NUMBER:", BvDAssign[0]);
      }
    }

  }
  stepsToImport(BvDAssignBvd, BvDAssignGuo, BvDAssignHq) {

    this.cmpDetails=[]
    this.grpDisp = false;
    this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityIdentifierTypeName=BVD ID&value=${BvDAssignBvd}`).subscribe((data: any) => { // Checks if (BVD_ID_NUMBER) is associated to a BE 
      if (data['business-entity-identifiers'].length > 0) { // YES
        this.BE_Check = true;
        console.info("This Supplier is already available in ISA");
        data['business-entity-identifiers'].forEach(entityData=>{
          this.supplierService.getBusinessEntities(`${this.Config.ApiSupplierUrl}business-entities/${entityData['businessEntityId']}`).subscribe(cmpData=>{
            let companyDetail = {
              id:cmpData['companyAllianceIdentifier'],
              name:cmpData['companyLegalName'],
              rowId:cmpData['companyId']
            }
          this.cmpDetails.push(companyDetail)
        })})
      } else { // No then
        this.BE_Check = false;
        console.info("Supplier Not Exists");
        if (BvDAssignHq != 'undefined' && BvDAssignHq != 'null' && BvDAssignHq != '') { // if(1) HQ_BVD_ID_NUMBER is not null then.
          this.BvDbySplitNumber = BvDAssignHq;
          console.info("HQ_BVD_ID is not NULL");

          this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityIdentifierTypeName=BVD ID&value=${this.NL_HQ_BVD_ID_NUMBER}`).subscribe((data20: any) => { //checks if (HQ_BVD_ID_NUMBER) is associated to a BE

            if (data20['business-entity-identifiers'].length > 0) { //YES Condition then,
              this.hqBvdCheck = true;
              console.info("1# HQ_BvD_ID assiciated to BE");
              console.info("1# SITE will be create with BVD_ID_NUMBER");
              this.loadingImpsupp = false;
              this.supplierService.getGroupIdentifiers(`${this.Config.ApiSupplierUrl}group-identifiers?groupIdentifierKeyName=BVD&value=${this.NL_GUO_BVD_ID_NUMBER}`).subscribe((checkForGUOBVDatGroup: any) => {
                if (checkForGUOBVDatGroup['group-identifiers'].length > 0) {
                  this.guoBvdCheck = true;
                } else {
                  this.guoBvdCheck = false;
                  this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityIdentifierTypeName=BVD ID&value=${this.NL_GUO_BVD_ID_NUMBER}`).subscribe((checkForGUOBVDatBE: any) => {
                    if (checkForGUOBVDatBE['business-entity-identifiers'].length > 0) {
                      this.guoBvdCheck = true;
                    } else {
                      this.guoBvdCheck = false;
                    }
                  });
                }
              });
              setTimeout(() => {
                  this.NL_Case_Occur = 1;
                  this.fetchCompany2(this.NL_HQ_BVD_ID_NUMBER);
              }, THREE_THOUSAND_MS);
            } else {  //NO Condition then,
              console.info("HQ_BvD_ID is not assiciated to Business Entity");
              this.hqBvdCheck = false;
              if (BvDAssignGuo != 'undefined' && BvDAssignGuo != 'null' && BvDAssignGuo != '') { //Checks GUO_BVD_ID_NUMBER is not null then
                console.info("GUO_BVD_ID_NUMBER is not NULL");

                this.supplierService.getGroupIdentifiers(`${this.Config.ApiSupplierUrl}group-identifiers?groupIdentifierKeyName=BVD&value=${this.NL_GUO_BVD_ID_NUMBER}`).subscribe((data13: any) => {
                  if (data13['group-identifiers'].length > 0) {
                    console.info("Group exists and the Group is associated to that BVD");
                    this.guoBvdCheck = true;
                    setTimeout(() => {
                        this.getBvdinterfaceDetails(this.NL_GUO_BVD_ID_NUMBER, "GUO", FIVE);
                    }, THREE_THOUSAND_MS);
                  } else {
                    this.guoBvdCheck = false;
                    this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityIdentifierTypeName=BVD ID&value=${this.NL_GUO_BVD_ID_NUMBER}`).subscribe((data21: any) => {
                      if (data21['business-entity-identifiers'].length > 0) { //YES (Associated to BE)
                        console.info("2* GUO_BVD_ID Associated to Business Entity");
                        this.guoBvdCheck = true;
                        let businessEntId = data21['business-entity-identifiers'][0]['businessEntityId'];

                        this.supplierService.getBusinessEntityById(`${this.Config.ApiSupplierUrl}business-entities/${businessEntId}`).subscribe((data23: any) => {
                          if (data23) {
                            this.supplierService.getGroupAssignments(`${this.Config.ApiSupplierUrl}group-assignments?apoStatus=ACTIVE&companyId=${data23['companyId']}`).subscribe((data33: any) => {

                              if (data33['group-assignments'].length > 0) {
                                console.info("Group exists and the Group is ACTIVELY linked to that BVD");
                                this.grpDisp = true
                                setTimeout(() => {
                                    this.NL_Case_Occur = TWO;
                                    this.groupIdHolder = data33['group-assignments'][0]['groupId'];
                                    this.getBvdinterfaceDetails(this.NL_GUO_BVD_ID_NUMBER, "GUO", FIVE);
                                }, THREE_THOUSAND_MS);

                                console.info("2* COMPANY will be create with HQ_BVD_ID_NUMBER");
                                console.info("2* SITE will be create with BVD_ID_NUMBER");



                              } else {

                                console.info("group not actively linked to the bvd so send mail for tech err");
                                this.groupLinkError = ` There is no Group associated to that existing BVD: ${this.NL_GUO_BVD_ID_NUMBER}`
                                this.checkConditionAndNotify2()
                              }
                            });
                          } else {

                            this.loadingImpsupp = false;
                            console.info("new group => guo_bvd does not exist at BE level");
                            setTimeout(() => {
                                this.NL_Case_Occur = TWO;
                                this.GroupBvDdetails['groupId'] = "";
                                this.importSuppStep2 = true;
                                this.getBvdinterfaceDetails(this.NL_GUO_BVD_ID_NUMBER, 'GUO', TWO);
                            }, THREE_THOUSAND_MS);
                          }
                        });

                      } else { //NO (Not Associated to BE)
                        this.guoBvdCheck = false;
                        console.info("3@ GUO_BVD_ID not associated to BE");
                        setTimeout(() => {
                            this.NL_SaveGrp_ID = this.NL_GUO_BVD_ID_NUMBER;
                            this.NL_Case_Occur = THREE;
                            this.getBvdinterfaceDetails(this.NL_GUO_BVD_ID_NUMBER, "GUO", THREE);
                        }, THREE_THOUSAND_MS);

                        console.info("3@ GROUP will be create with GUO_BVD_ID_NUMBER");
                        console.info("3@ COMPANY will be create with HQ_BVD_ID_NUMBER");
                        console.info("3@ SITE will be create with BVD_ID_NUMBER");

                      }
                    });
                  }
                });
              } else {
                console.info("4_ GUO_BVD_ID_NUMBER is null1");


                setTimeout(() => {

                    this.NL_SaveGrp_ID = this.NL_HQ_BVD_ID_NUMBER;
                    this.NL_Case_Occur = FOUR;
                    this.getBvdinterfaceDetails(this.NL_HQ_BVD_ID_NUMBER, "HQ", FOUR);




                }, THREE_THOUSAND_MS);

                console.info("4_ GROUP will be create with HQ_BVD_ID_NUMBER");
                console.info("4_ SITE will be create with BVD_ID_NUMBER");



              }

            }
          });

        } else { // else((1) part
          console.info("HQ_BvD_ID is null");

          if (BvDAssignGuo != 'undefined' && BvDAssignGuo != 'null' && BvDAssignGuo != '') { // GUO_BVD_ID_NUMBER is not null then,
            console.info("GUO_BVD_ID_NUMBER is not null2");

            this.supplierService.getGroupIdentifiers(`${this.Config.ApiSupplierUrl}group-identifiers?groupIdentifierKeyName=BVD&value=${this.NL_GUO_BVD_ID_NUMBER}`).subscribe((data13: any) => {
              if (data13['group-identifiers'].length > 0) {
                console.info("Group exists and the Group is associated to that BVD");
                this.guoBvdCheck = true;
                setTimeout(() => {

                    this.NL_Case_Occur = FIVE;
                    this.getBvdinterfaceDetails(this.NL_GUO_BVD_ID_NUMBER, '', FIVE);




                }, THREE_THOUSAND_MS);
              } else {
                this.guoBvdCheck = false;
                this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityIdentifierTypeName=BVD ID&value=${this.NL_GUO_BVD_ID_NUMBER}`).subscribe((data22: any) => {


                  if (data22['business-entity-identifiers'].length > 0) { //YES (Associated to BE)
                    console.info("5& GUO_BVD_ID Associated to BE");
                    console.info("5& COMPANY will be create with BVD_ID_NUMBER");
                    this.guoBvdCheck = true;
                    let businessEntId = data22['business-entity-identifiers'][0]['businessEntityId'];

                    this.supplierService.getBusinessEntities(`${this.Config.ApiSupplierUrl}business-entities/${businessEntId}`).subscribe((data23: any) => {
                      if (data23) {
                        this.supplierService.getGroupAssignments(`${this.Config.ApiSupplierUrl}group-assignments?apoStatus=ACTIVE&companyId=${data23['companyId']}`).subscribe((data33: any) => {

                          if (data33['group-assignments'].length > 0) {

                            console.info("Group exists and the Group is ACTIVELY linked to that BVD");
                            setTimeout(() => {
                              if (this.guoBvdCheck == true) {
                                this.groupIdHolder = data33['group-assignments'][0]['groupId'];
                                this.NL_Case_Occur = FIVE;
                                this.getBvdinterfaceDetails(this.NL_GUO_BVD_ID_NUMBER, '', FIVE);
                                this.checkForStopOrContinue = false;
                              } else {
                                this.checkForStopOrContinue = true;
                              }
                            }, THREE_THOUSAND_MS);
                          } else {

                            console.info("group not actively linked to the bvd ");
                            this.groupLinkError = ` There is no Group associated to that existing BVD: ${this.NL_GUO_BVD_ID_NUMBER}`
                            this.checkConditionAndNotify2()
                          }
                        });
                      } else {

                        console.info("new group => guo_bvd does not exist at BE level");
                        setTimeout(() => {

                            this.getBvdinterfaceDetails(this.NL_GUO_BVD_ID_NUMBER, '', FIVE);




                        }, THREE_THOUSAND_MS);
                      }
                    });
                  } else { // (Not Associated to BE )
                    this.guoBvdCheck = false;
                    console.info("6% GUO_BVD_ID not Associated to BE");
                    setTimeout(() => {

                        if (BvDAssignBvd == this.NL_GUO_BVD_ID_NUMBER) {
                          console.info("6% special case GUO==BVD");
                          this.NL_Case_Occur = EIGHT;
                        } else {
                          this.NL_Case_Occur = SIX;
                        }
                        this.NL_SaveGrp_ID = this.NL_GUO_BVD_ID_NUMBER;
                        this.getBvdinterfaceDetails(this.NL_GUO_BVD_ID_NUMBER, "GUO", SIX);




                    }, THREE_THOUSAND_MS);

                    console.info("6% Group will be create with GUO_BVD_ID_NUMBER");
                    console.info("6% COMPANY will be create with BVD_ID_NUMBER");





                  }

                });
              }
            });
          } else { // GUO_BVD_ID_NUMBER is null
            console.info("7$ GUO_BVD_ID_NUMBER is null");
            setTimeout(() => {

                this.NL_SaveGrp_ID = this.NL_BVD_ID_NUMBER;

                this.NL_Case_Occur = SEVEN;
                this.getBvdinterfaceDetails(this.NL_BVD_ID_NUMBER, "BvD", SEVEN);
            }, THREE_THOUSAND_MS);

            console.info("7$ Group will be create with BVD_ID_NUMBER");


          }
        }
      }
    });
  }

    ImportCheckNextNew() {
    console.info('[Retry] start ImportCheckNextNew retry=', this.retry);
    console.info('noreload',this.noreload)
    console.info("Next", this.NL_Case_Occur);
    console.info('Array.isArray(this.GroupBvDdetails)', Array.isArray(this.GroupBvDdetails));
    console.info('NL_flagCompany', this.NL_flagCompany);
    console.info('NL_flagCompany_step2Init', this.NL_flagCompany_step2Init);
    console.info('NL_flagSite_step3Init', this.NL_flagSite_step3Init);
    console.info('NL_flagSite', this.NL_flagSite);
    console.info('NL_BVD_ID_NUMBER', this.NL_BVD_ID_NUMBER);
    console.info('NL_HQ_BVD_ID_NUMBER', this.NL_HQ_BVD_ID_NUMBER);
    console.info('NL_BvDdataCnS', this.NL_BvDdataCnS);
    console.info('GroupBvDdetails', this.GroupBvDdetails);
    this.getCpyShortNameTypes()
    this.C2bDisplay=false
    this.disableNext = false;
    this.CompanySelectDisab = true;
    this.nextBtnNotVisible = true;
    if (this.NL_Case_Occur == 1) {

      if (this.NL_Case_Occur == 1 && this.NL_flagSite_step3Init == false) {
        console.info("Site Initializing From 1");
        console.info(`Company ID is : ${this.companyRowId}`);
        this.importSuppStep3 = true;
        this.loadingImpsupp3 = true;
        this.getBvdinterfaceSite(this.NL_BVD_ID_NUMBER, this.NL_HQ_BVD_ID_NUMBER);//Site Initializing
        this.NL_flagSite_step3Init = true;
      } else if (this.NL_Case_Occur == 1 && this.NL_flagSite_step3Init == true && this.NL_flagSite == false) {
        this.importSuppStep3 = true;
        this.loadingImpsupp3 = true;
        console.info("Site Creating From 1");
        
        // Check if site already created for this BVD ID (Case 1 duplicate prevention)
        if (this.createdSiteBvdIds.has(this.NL_BVD_ID_NUMBER)) {
          console.info("[DUPLICATE PREVENTION] Site already created for BVD:", this.NL_BVD_ID_NUMBER);
          this.NL_flagSite = true;
          this.ImportDone = true;
        } else {
          if(this.cmpShortName == ''){
            this.supplierService.getCompanies(`${this.Config.ApiSupplierUrl}companies/${this.companyRowId}`).subscribe(data1 => {
              let cmp= data1['legalName'].split(' ').join('');
              if(cmp.length <=TEN){
                this.cmpShortName = cmp.padEnd(TEN);
              }else if(cmp.length > TEN){
                this.cmpShortName = cmp.slice(0,TEN);
              }
              if (this.createdSiteBvdIds.has(this.NL_BVD_ID_NUMBER)) {
                console.info("[DUPLICATE PREVENTION] Site already created for BVD:", this.NL_BVD_ID_NUMBER);
              } else {
                let city = this.apiService.hasNoSpecialCharacters(this.SitesInfo['CITY_STANDARDIZED'], this.SitesInfo['CITY']);
                this.saveSitesDetails(this.SitesInfo['NAME'], this.SitesInfo['COUNTRY'], this.SitesInfo['COUNTRY_ISO_CODE'], city, this.SitesInfo['POSTCODE'], this.companyRowId, this.NL_BVD_ID_NUMBER, "S", this.SitesInfo,'importDone');
              }
            })
          }else{
            if (this.createdSiteBvdIds.has(this.NL_BVD_ID_NUMBER)) {
              console.info("[DUPLICATE PREVENTION] Site already created for BVD:", this.NL_BVD_ID_NUMBER);
            } else {
              let city = this.apiService.hasNoSpecialCharacters(this.SitesInfo['CITY_STANDARDIZED'], this.SitesInfo['CITY']);
              this.saveSitesDetails(this.SitesInfo['NAME'], this.SitesInfo['COUNTRY'], this.SitesInfo['COUNTRY_ISO_CODE'], city, this.SitesInfo['POSTCODE'], this.companyRowId, this.NL_BVD_ID_NUMBER, "S", this.SitesInfo,'importDone');
            }
          }
          this.NL_flagSite = true;
          this.ImportDone = true;
        }
      } else if (this.NL_flagSite_step3Init == true && this.NL_flagSite == true) {
        // Case 1 already complete - ensure ImportDone is set
        console.info("Case 1 already complete - site already created");
        this.ImportDone = true;
        this.checkConditionAndNotify();
      }
    } else if (this.NL_Case_Occur == TWO) {

      if (this.NL_Case_Occur == TWO && this.NL_flagCompany == false && this.NL_flagCompany_step2Init == false) {
        console.info("Company Initialize 2");
        this.importSuppStep2 = true;
        this.loadingImpsupp2 = true;
        this.loadCompanySection = false;
        this.NL_flagCompany = true;
        this.getBvdinterfaceCS(this.NL_HQ_BVD_ID_NUMBER, false, true);//Company Initialize
        this.NL_flagCompany_step2Init = true;
      } else if (this.NL_Case_Occur == TWO && this.NL_flagCompany == false && this.NL_flagCompany_step2Init == true) {
        console.info("Company Creating From 2");
        if(this.createdCompanyBvdIds.has(this.NL_HQ_BVD_ID_NUMBER)){
                console.info("[DUPLICATE PREVENTION] Company already created for BVD:", this.NL_HQ_BVD_ID_NUMBER);
        }else{
          this.importSuppStep2 = true;
          this.loadingImpsupp2 = true;
          this.loadCompanySection = false;
          this.saveCompanyDetails(this.NL_BvDdataCnS['NAME'], this.NL_BvDdataCnS['NATIONAL_ID'], this.GroupBvDdetails['groupId'], this.NL_HQ_BVD_ID_NUMBER, 'N', this.NL_BvDdataCnS['NATIONAL_ID_LABEL'], 'Y', 'N', this.NL_BvDdataCnS);
          this.NL_flagCompany = true;
        }
      } else if (this.NL_Case_Occur == TWO && this.NL_flagCompany == true && this.NL_flagSite_step3Init == false) {
        console.info("Site Initializing From 2");
        this.importSuppStep3 = true;
        this.loadingImpsupp3 = true;
        this.getBvdinterfaceSite(this.NL_BVD_ID_NUMBER, this.NL_HQ_BVD_ID_NUMBER);//Site Initializing
        this.NL_flagSite_step3Init = true;
      } else if (this.NL_Case_Occur == TWO && this.NL_flagCompany == true && this.NL_flagSite_step3Init == true && this.NL_flagSite == false) {
        this.importSuppStep3 = true;
        this.loadingImpsupp3 = true;
        console.info("Site Creating From 2");

        this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?value=${this.NL_BVD_ID_NUMBER}&businessEntityIdentifierTypeName=BVD ID`).subscribe(data2 => {
          if (data2['business-entity-identifiers'].length > 0) {
            this.fetchSiteDetails();            
          } else {
            if (this.createdSiteBvdIds.has(this.NL_BVD_ID_NUMBER)) {
              console.info("[DUPLICATE PREVENTION] Site already created for BVD:", this.NL_BVD_ID_NUMBER);
            } else {
              let city = this.apiService.hasNoSpecialCharacters(this.SitesInfo['CITY_STANDARDIZED'], this.SitesInfo['CITY']);
              this.saveSitesDetails(this.SitesInfo['NAME'], this.SitesInfo['COUNTRY'], this.SitesInfo['COUNTRY_ISO_CODE'], city, this.SitesInfo['POSTCODE'], this.companyRowId, this.NL_BVD_ID_NUMBER, "S", this.SitesInfo,'importDone');
            }
          }
          // Move flag setting INSIDE the async callback for Case 2 (same fix as Case 3)
          this.NL_flagSite = true;
          this.ImportDone = true;
        });


      } else if (this.NL_flagCompany == true && this.NL_flagSite_step3Init == true && this.NL_flagSite == true) {
        // Case 2 already complete - ensure ImportDone is set
        console.info("Case 2 already complete - company and site already created");
        this.ImportDone = true;
        this.checkConditionAndNotify();
      }
    } else if (Array.isArray(this.GroupBvDdetails)) {
      console.info("Group Not Exists");

      if (this.NL_Case_Occur == THREE || this.NL_Case_Occur == SIX || this.NL_Case_Occur == EIGHT) {
        console.info('case 3,6')
        if(this.createdGroupBvdIds.has(this.NL_GUO_BVD_ID_NUMBER)){
          console.info("[DUPLICATE PREVENTION] Group already created for BVD:", this.NL_GUO_BVD_ID_NUMBER);
        }else{
        // Use BvDdata['NAME'] if available, otherwise fallback to original GUO_NAME from sveCompanies[3]
        let groupName = this.BvDdata['NAME'];
        if (!groupName || groupName === 'undefined' || groupName.trim() === '') {
          // First try GUO_NAME from sveCompanies[3]
          groupName = this.sveCompanies[3];
          console.info("[FALLBACK] Trying original GUO_NAME from sveCompanies:", groupName);
          // If GUO_NAME is also undefined, use NAME from sveCompanies[4]
          if (!groupName || groupName === 'undefined' || groupName === 'null' || (typeof groupName === 'string' && groupName.trim() === '')) {
            groupName = this.sveCompanies[4];
            console.info("[FALLBACK] GUO_NAME undefined, using NAME from sveCompanies:", groupName);
          }
        }
        this.saveGroupDetails(this.NL_GUO_BVD_ID_NUMBER, groupName);
        this.NL_flagGroup = true;
        }
      }
      if (this.NL_Case_Occur == FOUR) {
        if(this.createdGroupBvdIds.has(this.NL_GUO_BVD_ID_NUMBER)){
          console.info("[DUPLICATE PREVENTION] Group already created for BVD:", this.NL_GUO_BVD_ID_NUMBER);
        }else{
        console.info('case 4')
        // Use BvDdata['NAME'] if available, otherwise fallback to original NAME from sveCompanies[4]
        let groupName = this.BvDdata['NAME'];
        if (!groupName || groupName === 'undefined' || groupName.trim() === '') {
          groupName = this.sveCompanies[4]; // Original NAME from BvDnumber
          console.info("[FALLBACK] Using original NAME from sveCompanies:", groupName);
        }
        this.saveGroupDetails(this.NL_HQ_BVD_ID_NUMBER, groupName);
        }
      }
      if (this.NL_Case_Occur == SEVEN) {
        if(this.createdGroupBvdIds.has(this.NL_GUO_BVD_ID_NUMBER)){
          console.info("[DUPLICATE PREVENTION] Group already created for BVD:", this.NL_GUO_BVD_ID_NUMBER);
        }else{
        console.info('case 7')
        // Use BvDdata['NAME'] if available, otherwise fallback to original NAME from sveCompanies[4]
        let groupName = this.BvDdata['NAME'];
        if (!groupName || groupName === 'undefined' || groupName.trim() === '') {
          groupName = this.sveCompanies[4]; // Original NAME from BvDnumber
          console.info("[FALLBACK] Using original NAME from sveCompanies:", groupName);
        }
        this.saveGroupDetails(this.NL_BVD_ID_NUMBER, groupName);
        }
      }
    } else {


      if (this.NL_Case_Occur == THREE && this.NL_flagCompany == false && this.NL_flagCompany_step2Init == false && (this.NL_HQ_BVD_ID_NUMBER == this.NL_GUO_BVD_ID_NUMBER)) {
        console.info("Company Initialize 3 when guo_bvd is same as hq_bvd");
        this.importSuppStep2 = true;
        this.loadingImpsupp2 = true;
        this.loadCompanySection = false;
        this.getBvdinterfaceCS(this.NL_HQ_BVD_ID_NUMBER, true, false);//Company Creation
        this.NL_flagCompany_step2Init = true;
        this.NL_flagCompany = true;
      } else if (this.NL_Case_Occur == THREE && this.NL_flagCompany == false && this.NL_flagCompany_step2Init == false) {
        console.info("Company Initialize 3");
        this.importSuppStep2 = true;
        this.loadingImpsupp2 = true;
        this.loadCompanySection = false;
        this.getBvdinterfaceCS(this.NL_HQ_BVD_ID_NUMBER, false, true);//Company Creation
        this.NL_flagCompany_step2Init = true;
        this.NL_flagCompany = true;
      } else if (this.NL_Case_Occur == THREE && this.NL_flagCompany == false && this.NL_flagCompany_step2Init == true) {
        console.info("Company Creating From 3");
        if(this.createdCompanyBvdIds.has(this.NL_HQ_BVD_ID_NUMBER)){
          console.info("[DUPLICATE PREVENTION] Company already created for BVD:", this.NL_HQ_BVD_ID_NUMBER);
        }else{
          this.importSuppStep2 = true;
          this.loadingImpsupp2 = true;
          this.loadCompanySection = false;
          console.info("**** Create Group DONE ****");
          this.saveCompanyDetails(this.NL_BvDdataCnS['NAME'], this.NL_BvDdataCnS['NATIONAL_ID'], this.GroupBvDdetails['groupId'], this.NL_HQ_BVD_ID_NUMBER, 'N', this.NL_BvDdataCnS['NATIONAL_ID_LABEL'], 'Y', 'N', this.NL_BvDdataCnS);
          this.NL_flagCompany = true;
        }
      } else if (this.NL_Case_Occur == THREE && this.NL_flagCompany == true && this.NL_flagSite_step3Init == false) {
        console.info("Site Initializing From 3");
        this.importSuppStep3 = true;
        this.loadingImpsupp3 = true;
        this.getBvdinterfaceSite(this.NL_BVD_ID_NUMBER, this.NL_HQ_BVD_ID_NUMBER);//Site Initializing
        this.NL_flagSite_step3Init = true;
      } else if (this.NL_Case_Occur == THREE && this.NL_flagCompany == true && this.NL_flagSite_step3Init == true && this.NL_flagSite == false) {
        this.importSuppStep3 = true;
        this.loadingImpsupp3 = true;
        console.info("Site Creating From 3");
        this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?value=${this.NL_BVD_ID_NUMBER}&businessEntityIdentifierTypeName=BVD ID`).subscribe(data2 => {
          // Check if site already created for this BVD ID
          if (data2['business-entity-identifiers'].length > 0) {
            this.getBvdinterfaceSite(this.NL_BVD_ID_NUMBER, this.NL_HQ_BVD_ID_NUMBER);//   Site Creation             
          } else {
            if (this.createdSiteBvdIds.has(this.NL_BVD_ID_NUMBER)) {
              console.info("[DUPLICATE PREVENTION] Site already created for BVD:", this.NL_BVD_ID_NUMBER);
            } else {
              let city = this.apiService.hasNoSpecialCharacters(this.SitesInfo['CITY_STANDARDIZED'], this.SitesInfo['CITY']);
              this.saveSitesDetails(this.SitesInfo['NAME'], this.SitesInfo['COUNTRY'], this.SitesInfo['COUNTRY_ISO_CODE'], city, this.SitesInfo['POSTCODE'], this.companyRowId, this.NL_BVD_ID_NUMBER, "S", this.SitesInfo,'importDone');
            }
        }
          // Move flag setting INSIDE the async callback
          this.NL_flagSite = true;
          this.ImportDone = true;
        });
      } else if (this.NL_Case_Occur == THREE && this.NL_flagCompany == true && this.NL_flagSite_step3Init == true && this.NL_flagSite == true) {
        // Case 3 already complete - ensure ImportDone is set
        console.info("Case 3 already complete - group, company and site already created");
        this.ImportDone = true;
        this.checkConditionAndNotify();
      }

      if (this.NL_Case_Occur == SEVEN && this.NL_flagCompany == false) {
        console.info("Fetch Company Details from 7");
        this.ImportDone = true;
        this.checkConditionAndNotify();
      } else if (this.NL_Case_Occur == SEVEN && this.NL_flagCompany == true && this.NL_flagSite == false) {
        console.info("Just Site Load here 7");
        this.ImportDone = true;
        this.checkConditionAndNotify();
      }
      if ((this.NL_Case_Occur == FIVE) && this.loadingImpsupp == false && (this.importSuppStep2 == false || this.importSuppStep3 == false)) {
        if (this.importSuppStep2 == false) {
          console.info('sp case 6 called');

          this.importSuppStep2 = true;
          this.loadingImpsupp2 = true;
          this.loadCompanySection = false;
          this.getBvdinterfaceCS(this.NL_BVD_ID_NUMBER, false, true);
        } else {
          console.info('sp case 6 called-2');
          console.info('%c special case 6 called for the second time>>>>', "color : aqua;font-weight:bold", this.BEIDval);
          this.ImportDone = true;
          this.checkConditionAndNotify();
        }
      } else if (this.NL_Case_Occur == FIVE || this.NL_Case_Occur == SIX) {
        if (this.NL_Case_Occur == SIX && this.importSuppStep2 == false) {
          this.loadingImpsupp2 = true;
          this.importSuppStep2 = true;
          this.loadCompanySection = true;
          this.getBvdinterfaceCS(this.NL_BVD_ID_NUMBER, false, true);
        } else {
          this.ImportDone = true;
          this.checkConditionAndNotify();
        }
      } else if (this.NL_Case_Occur == EIGHT) {
        this.ImportDone = true;
        this.checkConditionAndNotify();
      } else if (this.NL_Case_Occur == FOUR && this.NL_flagCompany == false) {
        console.info("Fetch Company Details from 4");
        this.NL_flagCompany = true;
      } else if (this.NL_Case_Occur == FOUR && this.NL_flagSite_step3Init == false && this.NL_flagCompany == true) {
        console.info("Site Initializing From 4");
        console.info(`Company ID is : ${this.companyRowId}`);
        this.importSuppStep3 = true;
        this.loadingImpsupp3 = true;
        this.getBvdinterfaceSite(this.NL_BVD_ID_NUMBER, this.NL_HQ_BVD_ID_NUMBER);
        this.NL_flagSite_step3Init = true;
      } else if (this.NL_Case_Occur == FOUR && this.NL_flagSite_step3Init == true && this.NL_flagSite == false) {
        this.importSuppStep3 = true;
        this.loadingImpsupp3 = true;
        console.info("Site Creating From 4");
        
        // Check if site already created for this BVD ID (Case 4 duplicate prevention)
        if (this.createdSiteBvdIds.has(this.NL_BVD_ID_NUMBER)) {
          console.info("[DUPLICATE PREVENTION] Site already created for BVD:", this.NL_BVD_ID_NUMBER);
        } else {
          this.saveSitesDetails(this.SitesInfo['NAME'], this.SitesInfo['COUNTRY'], this.SitesInfo['COUNTRY_ISO_CODE'], this.SitesInfo['CITY'], this.SitesInfo['POSTCODE'], this.companyRowId, this.NL_BVD_ID_NUMBER, "S", this.SitesInfo,'importDone');
        }
        this.NL_flagSite = true;
        this.ImportDone = true;
      }
    }

  }

  fetchSiteDetails() {
    if (this.SiteRowID != "") {
      this.siteService.getSites(`${this.Config.ApiSitesUrl}sites?_page=1&rowId=${this.SiteRowID}`).subscribe((dataSI: any) => {
        this.SitesInfo['identifier'] = dataSI['sites'][0]['identifier'];
        console.info("this.SitesInfo", this.SitesInfo);
        this.loadSiteSection = true;
        this.loadingImpsupp3 = false;
        if(this.NL_Case_Occur == 1){
          this.checkConditionAndNotify()
        }
      });
    } else {
      this.loadSiteSection = true;
      this.loadingImpsupp3 = false;
    }
    if (this.BE_Check==false && this.ImportDone==false && this.checkForStopOrContinue==false) {
      setTimeout(function () {
        console.info('got clicked here')
        this.ImportCheckNextNew()
      }.bind(this), TWO_THOUSAND_MS);
    }

  }
  fetchCompany2(BvD, from = false) {
    this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?value=${BvD}`).subscribe((dataC: any) => {
      if (dataC['business-entity-identifiers'].length > 0) {
        this.supplierService.getBusinessEntities(`${this.Config.ApiSupplierUrl}business-entities?identifier=${dataC['business-entity-identifiers'][0]['businessEntityAllianceIdentifier']}`).subscribe((dataCM: any) => {
          console.info("CCCCM", dataCM);
          this.companyRowId = dataCM['business-entities'][0]['companyId'];
          this.latestCompanyId = dataCM['business-entities'][0]['companyId']
          if (from == true) {
            this.fetchCompanyDetails(BvD);
          } else {
            this.ImportCheckNextNew();
          }
        });
      } else {
        this.companyRowId = "No";
      }
    });
  }
  fetchCompanyDetails(CompanyBvD) {
    this.companyInfos = "";
    this.companyInfos = [];
    this.BEIDval = "";
    this.BEIDval = [];
    this.loadingImpsupp2 = true;
    this.loadCompanySection = false;

    var cmpID = "";
    if (this.companyRowId != "" && this.companyRowId != undefined) {
      console.info("From : this.companyRowId");
      cmpID = this.companyRowId;
      this.supplierService.getBusinessEntities(`${this.Config.ApiSupplierUrl}business-entities?companyId=${cmpID}&isHQ=Y`).subscribe((data2: any) => {
        var BEID = [];
        if (data2['business-entities'].length > 0) {
          this.companyInfos = data2['business-entities'][0];
          data2['business-entities'].forEach(element => {
            BEID.push(element.row_id);
          });
          if (BEID.length > 0) {
            this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityIdentifierTypeName=BVD ID&businessEntityId=in(${BEID})`).subscribe(data3 => {
                console.info("be Array", data3);
                if (data3['business-entity-identifiers'].length > 0) {
                  var y = 1;
                  data3['business-entity-identifiers'].forEach(element => {
                    this.BEIDval[element.businessEntityId] = element.value;
                    this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityIdentifierTypeName=BVD ID&value=*${element.value}`).subscribe(data0 => {
                      if (data0['business-entity-identifiers'].length > 0) {
                        this.supplierService.getSiteAssignments(`${this.Config.ApiSupplierUrl}site-assignments?businessEntityId=in(${data0['business-entity-identifiers'][0]['businessEntityId']})`).subscribe(data30 => {
                          if (data30['site-assignments'].length > 0) {
                            let c = data30['site-assignments'][0].site.href.split('/');
                            this.siteService.getSites(`${this.Config.ApiSitesUrl}sites?rowId=in(${c[1]})`).subscribe(data50 => {
                              if (data50['sites'].length > 0) {
                                this.BEIDval[element.value] = data50['sites'][0]['identifier']
                              }
                              this.loadingImpsupp2 = false;
                              this.loadCompanySection = true;
                              this.checkConditionAndNotify();
                            });
                          } else {
                            this.loadingImpsupp2 = false;
                            this.loadCompanySection = true;
                            if ((this.NL_flagCompany === true && this.NL_flagCompany_step2Init === true && this.NL_flagSite_step3Init === true)) {
                              this.checkConditionAndNotify();
                            }
                          }
                        });

                      } else {
                        this.loadingImpsupp2 = false;
                        this.loadCompanySection = true;
                        if ((this.NL_flagCompany === true && this.NL_flagCompany_step2Init === true && this.NL_flagSite_step3Init === true)) {
                          this.checkConditionAndNotify();
                        }
                      }
                    });

                  });
                  console.info("sA", this.BEIDval);
                } else {
                  this.loadingImpsupp2 = false;
                  this.loadCompanySection = true;
                }
              });

          } else {
            this.loadingImpsupp2 = false;
            this.loadCompanySection = true;
          }

        } else {
          this.loadingImpsupp2 = false;
          this.loadCompanySection = true;
        }
        console.info("Company Infos", this.companyInfos);
         if (this.BE_Check==false && this.ImportDone==false && this.checkForStopOrContinue==false) {
         setTimeout(function () {
          console.info('got clicked here')
          this.ImportCheckNextNew()
        }.bind(this), TWO_THOUSAND_MS);
    }
      });
    } else {
      this.fetchCompany2(CompanyBvD, true);
    }

  }
  getBvdinterfaceSite(BvD_HQBvD_GuoBvD, _cmpBVD = '') {
    if(this.noreload == true){
      this.noreload = false
      this.siteDisableNext = true;
      this.NL_flagSite_step3Init = true;
      this.loadingImpsupp3 = false;
    } else {
    const datas = { "bvd-id": BvD_HQBvD_GuoBvD, import: "Y" }
    this.supplierService.createBvdInterface(`${this.Config.ApiSupplierUrl}bvd-interface`, datas).subscribe((data: any) => {
      var bVdDatas = JSON.parse(data.result);
      let tempData = '';
      if (this.SitesInfo.length !== 0 || this.SitesInfo !== '') {
        tempData = this.SitesInfo['identifier'];
      }
      this.SitesInfo = bVdDatas['Data'][0];
      
      // Handle undefined NAME field from BvD API response for Site
      if (!this.SitesInfo['NAME'] || this.SitesInfo['NAME'] === 'undefined') {
        this.SitesInfo['NAME'] = 'UNKNOWN SITE';
        console.info("[WARNING] BvD API returned undefined SITE NAME, using default: UNKNOWN SITE");
      }
      
      if (tempData != '') {
        this.SitesInfo['identifier'] = tempData;
        this.SitesInfo['c2b'] = this.c2bName
      }
      console.info("BvD-SiteLog", this.SitesInfo);
      if (this.BE_Check==false && this.ImportDone==false && this.checkForStopOrContinue==false) {
        this.siteDisableNext=false
        this.noreload = true
        setTimeout(function () {
          console.info('got clicked here')
          this.ImportCheckNextNew()
          this.siteDisableNext=true;
        }.bind(this), TWO_THOUSAND_MS);
      }
      this.NL_flagSite_step3Init = true;
      this.loadingImpsupp3 = false;

    }, _error => {
      this.groupCurrentStatus = 'BvD interface API error (Timeout)';
    });
  }
  }
  getBvdinterfaceCS(BvD_HQBvD_GuoBvD, LoadCompnay = false, loadCpyDet = false) {
    this.NL_BvDdataCnS = "";
    this.NL_BvDdataCnS = [];
    const datas = { "bvd-id": BvD_HQBvD_GuoBvD, import : "Y" }
    this.supplierService.createBvdInterface(`${this.Config.ApiSupplierUrl}bvd-interface`, datas).subscribe((data: any) => {
      var bVdDatas = JSON.parse(data.result);
      this.NL_BvDdataCnS = bVdDatas['Data'][0];
      
      // Handle undefined NAME field from BvD API response
      if (!this.NL_BvDdataCnS['NAME'] || this.NL_BvDdataCnS['NAME'] === 'undefined') {
        this.NL_BvDdataCnS['NAME'] = 'UNKNOWN COMPANY';
        console.info("[WARNING] BvD API returned undefined NAME, using default: UNKNOWN COMPANY");
      }
      
      console.info("BvD-CnS : this.NL_BvDdataCnS", this.NL_BvDdataCnS);
      console.info('load cpy', loadCpyDet);
      if (loadCpyDet == true) {
        if(this.createdCompanyBvdIds.has(this.NL_HQ_BVD_ID_NUMBER)){
          console.info("[DUPLICATE PREVENTION] Company already created for BVD:", this.NL_HQ_BVD_ID_NUMBER);
        }else{
          this.saveCompanyDetails(this.NL_BvDdataCnS['NAME'], this.NL_BvDdataCnS['NATIONAL_ID'], this.GroupBvDdetails['groupId'], BvD_HQBvD_GuoBvD, 'N', this.NL_BvDdataCnS['NATIONAL_ID_LABEL'], 'Y', 'N', this.NL_BvDdataCnS);
        }
      } else {
        if (LoadCompnay == true) {
          this.fetchCompanyDetails(BvD_HQBvD_GuoBvD);
        } else {
          this.loadingImpsupp2 = false;
        }
      }
    }, _error => {
      this.groupCurrentStatus = 'BvD interface API error (Timeout)';
    });
  }
  getBvdinterfaceDetails(BvD_HQBvD_GuoBvD, Type = null, from) {
    this.BvDdata = "";
    this.BvDdata = [];
    const datas = { "bvd-id": BvD_HQBvD_GuoBvD , "import": "Y" }
    this.groupCurrentStatus = 'Fetching BvD details from BvD interface';
    this.supplierService.createBvdInterface(`${this.Config.ApiSupplierUrl}bvd-interface`, datas).subscribe((data: any) => {
      var bVdDatas = JSON.parse(data.result);
      if (bVdDatas['Data'][0] != undefined && bVdDatas['Data'][0] != null) {
        this.BvDdata = bVdDatas['Data'][0];
        
        if (!this.BvDdata['NAME'] || this.BvDdata['NAME'] === 'undefined') {
          this.BvDdata['NAME'] = 'UNKNOWN ENTITY';
          console.info("[WARNING] BvD API returned undefined NAME in BvDdata, using default: UNKNOWN ENTITY");
        }
      }
      console.info(`BvDdata ${BvD_HQBvD_GuoBvD} ${Type}`, this.BvDdata);
      // Store GUO BVD data in separate variable to prevent overwrite by HQ data
      if (Type === "GUO") {
        this.NL_GUO_BvDdata = JSON.parse(JSON.stringify(this.BvDdata)); // Deep copy to prevent reference issues
        console.info("[FIX] Stored GUO BVD data separately:", this.NL_GUO_BvDdata['BVD_ID_NUMBER']);
      }
      if (from == THREE || from == FOUR || from == SIX || from == SEVEN || from == FIVE) {
        this.fetchGroupDetails(BvD_HQBvD_GuoBvD, Type);
        this.groupCurrentStatus = 'Fetching Group details';
      }
      if (from == 1 || from == TWO) {
        this.groupCurrentStatus = 'Fetching Group details';
        this.fetchGroupID(BvD_HQBvD_GuoBvD);
      }
    }, _error => {
      this.groupCurrentStatus = 'BvD interface API error (Timeout)';
    });
  }

  fetchGroupID(BvD_HQBvD_GuoBvD) {
    this.supplierService.getGroupIdentifiers(`${this.Config.ApiSupplierUrl}group-identifiers?groupIdentifierKeyName=BVD&value=${BvD_HQBvD_GuoBvD}`).subscribe((data3: any) => {
      if (data3['group-identifiers'].length > 0) {
        this.GroupBvDdetails['groupId'] = data3['group-identifiers'][0]['groupId'];
        console.info("Group ID is : ", this.GroupBvDdetails['groupId']);
      } else {
        console.info("Group ID not assigned");
        this.GroupBvDdetails['groupId'] = "";
      }
      this.CompanySelectDisab = false;
    });
  }

  fetchGroupDetails(BvD_HQBvD_GuoBvD, Type = null) {
    this.AllgroupCategories();
    const datas = { "bvd-id": BvD_HQBvD_GuoBvD }
    this.groupCurrentStatus = 'Fetching Group details';
    this.supplierService.getGroupIdentifiers(`${this.Config.ApiSupplierUrl}group-identifiers?groupIdentifierKeyName=BVD&value=${BvD_HQBvD_GuoBvD}`).subscribe((data3: any) => {
      console.info('fetchgroupdetails', data3);
      let groupName = this.BvDdata['NAME'];
      
      // Fallback chain: BvDdata['NAME'] -> sveCompanies[3] (GUO_NAME) -> sveCompanies[4] (NAME) -> 'UNKNOWN GROUP'
      if (!groupName || groupName === 'undefined' || groupName === 'null' || (typeof groupName === 'string' && groupName.trim() === '')) {
        groupName = this.sveCompanies[3]; // Try GUO_NAME
        console.info("[FALLBACK] fetchGroupDetails: Trying GUO_NAME from sveCompanies:", groupName);
        if (!groupName || groupName === 'undefined' || groupName === 'null' || (typeof groupName === 'string' && groupName.trim() === '')) {
          groupName = this.sveCompanies[4]; // Try NAME
          console.info("[FALLBACK] fetchGroupDetails: Trying NAME from sveCompanies:", groupName);
          if (!groupName || groupName === 'undefined' || groupName === 'null' || (typeof groupName === 'string' && groupName.trim() === '')) {
            groupName = 'UNKNOWN GROUP';
            console.info("[WARNING] All group name sources undefined, using default: UNKNOWN GROUP");
          }
        }
      }
      
      if (groupName != '' && groupName != undefined) {
        this.disableGrpShortNameLoad = true;
        this.setGroupNameDynamicFn(groupName);
      }
      if (data3['group-identifiers'].length > 0) {
        this.nextBtnNotVisible = true;
        this.GroupBvDdetails = data3['group-identifiers'][0];

        this.supplierService.getGroupById(`${this.Config.ApiSupplierUrl}groups/${data3['group-identifiers'][0]['groupId']}`).subscribe((data: any) => {
          this.groupCategoryModel = data['groupTypeCode'];
          if (this.groupCategoryModel != "") {
            this.GroupSelectDisab = true;
            this.CompanySelectDisab = false;
          }
          console.info("Group Cat Model", this.groupCategoryModel);

        });
        var curr_page = 1;
        this.supplierService.getGroupAssignments(`${this.Config.ApiSupplierUrl}group-assignments?_page=${curr_page}&groupId=${this.GroupBvDdetails['groupId']}`).subscribe((data: any) => {
          if (data['group-assignments'].length > 0) {
            this.GroupBvDdetails['companyAllianceIdentifier'] = data['group-assignments'][0]['companyAllianceIdentifier'];
          }
          if (Type == "Hide") {

          }
        });
        this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityIdentifierTypeName=BVD ID&value=*${BvD_HQBvD_GuoBvD}`).subscribe(data0 => {
          if (data0['business-entity-identifiers'].length > 0) {
            this.supplierService.getSiteAssignments(`${this.Config.ApiSupplierUrl}site-assignments?businessEntityId=in(${data0['business-entity-identifiers'][0]['businessEntityId']})`).subscribe(data30 => {
              if (data30['site-assignments'].length > 0) {
                let c = data30['site-assignments'][0].site.href.split('/');
                this.siteService.getSites(`${this.Config.ApiSitesUrl}sites?rowId=in(${c[1]})`).subscribe(data50 => {
                  if (data50['sites'].length > 0) {
                    this.GroupBvDdetails['siteAllianceIdentifier'] = data50['sites'][0]['identifier']
                  }
                  this.loadingImpsupp = false;
                  this.groupCurrentStatus = 'Fetching Site details';
                });
              } else {
                this.loadingImpsupp = false;
              }
            });

          } else {
            this.loadingImpsupp = false;
          }

        });

        this.supplierService.getGroupIdentifiers(`${this.Config.ApiSupplierUrl}group-identifiers?groupId=${data3['group-identifiers'][0]['groupId']}`).subscribe((data: any) => {
          if (data['group-identifiers'] && data['group-identifiers'] != null) {
            data['group-identifiers'].forEach(element => {
              if (element.groupIdentifierKeyName.toLowerCase() == 'mdm group') {
                this.GroupBvDdetails['shortNme'] = element.value;
              }
            });

          }
          this.disableNext = false;
        });
        console.info("G1", this.GroupBvDdetails);
      } else { 
        if (this.groupIdHolder != '') {
          this.groupCurrentStatus = 'Fetching Group details';
          this.nextBtnNotVisible = true;
          this.supplierService.getGroupIdentifiers(`${this.Config.ApiSupplierUrl}group-identifiers?groupId=${this.groupIdHolder}`).subscribe((data3: any) => {
            if (data3['group-identifiers'].length > 0) {
              this.GroupSelectDisab = true;
              this.CompanySelectDisab = this.grpDisp ? false : true;
              this.GroupBvDdetails = data3['group-identifiers'][0];
              this.GroupBvDdetails['shortNme'] = data3['group-identifiers'][0]['value'];
              this.GroupBvDdetails['value'] = BvD_HQBvD_GuoBvD;
              this.GroupBvDdetails['groupAllianceIdentifier'] = data3['group-identifiers'][0]['groupAllianceIdentifier'];

              this.supplierService.getGroupById(`${this.Config.ApiSupplierUrl}groups/${data3['group-identifiers'][0]['groupId']}`).subscribe((data: any) => {
                this.groupCategoryModel = data['groupTypeCode'];
                if (this.groupCategoryModel != "") {
                }
                console.info("Group Cat Model", this.groupCategoryModel);

              });
              var curr_page = 1;
              this.supplierService.getGroupAssignments(`${this.Config.ApiSupplierUrl}group-assignments?_page=${curr_page}&groupId=${this.GroupBvDdetails['groupId']}`).subscribe((data: any) => {
                if (data['group-assignments'].length > 0) {
                  this.GroupBvDdetails['companyAllianceIdentifier'] = data['group-assignments'][0]['companyAllianceIdentifier'];
                }
                if (Type == "Hide") {

                }
              });
              this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityIdentifierTypeName=BVD ID&value=*${BvD_HQBvD_GuoBvD}`).subscribe(data0 => {
                if (data0['business-entity-identifiers'].length > 0) {
                  this.supplierService.getSiteAssignments(`${this.Config.ApiSupplierUrl}site-assignments?businessEntityId=in(${data0['business-entity-identifiers'][0]['businessEntityId']})`).subscribe(data30 => {
                    if (data30['site-assignments'].length > 0) {
                      let c = data30['site-assignments'][0].site.href.split('/');
                      this.siteService.getSites(`${this.Config.ApiSitesUrl}sites?rowId=in(${c[1]})`).subscribe(data50 => {
                        if (data50['sites'].length > 0) {
                          this.GroupBvDdetails['siteAllianceIdentifier'] = data50['sites'][0]['identifier']
                        }
                        this.loadingImpsupp = false;
                        this.groupCurrentStatus = 'Fetching Site details';
                      });
                    } else {
                      this.loadingImpsupp = false;
                    }
                  });

                } else {
                  this.loadingImpsupp = false;
                }

              });

              this.supplierService.getGroupIdentifierKeysById(`${this.Config.ApiSupplierUrl}group-identifiers?groupId=${data3['group-identifiers'][0]['groupId']}`).subscribe((data: any) => {
                if (data['group-identifiers'] && data['group-identifiers'] != null) {
                  data['group-identifiers'].forEach(element => {
                    if (element.groupIdentifierKeyName.toLowerCase() == 'mdm group') {
                      this.GroupBvDdetails['shortNme'] = element.value;
                    }
                  });

                }
                this.disableNext = false;

                if (this.BE_Check == false && this.ImportDone == false && this.checkForStopOrContinue == false) {
                  console.info("next btn clicked-----");
                  if (!this.grpDisp) {
                    setTimeout(() => {
                      console.info('got clicked here')
                      this.ImportCheckNextNew();
                    }, TWO_THOUSAND_MS);
                  } else {
                    this.importSuppStep3 = true;
                  }
                }

              });
              console.info("G1", this.GroupBvDdetails);
            }
          });
        } else {
          console.info('in else show group select');
          this.loadingImpsupp = false;
          this.GroupSelectDisab = false;
        }
      }
    });
  }
  setGroupNameDynamicFn(grpName: string, loop = 'start', loopCount = 1, authGrpName = '', unoModify = '') {
    if (loop == 'start') {
      authGrpName = grpName.replace(/[^a-zA-Z0-9]/g, '').substring(0, SIX).toUpperCase();
      grpName = authGrpName;
    }
    else if (loop == 'continue') {
      if (loopCount == TWO) {
        unoModify = '6'
      }
      if (loopCount == TWO && grpName.length != SIX) {
        unoModify = grpName.length.toString();
        grpName = grpName.concat(this.digitsArray[0]);
      }
      let lastLetter = grpName.substr(grpName.length - 1);
      let indi1 = this.alphabetsArray.indexOf(lastLetter);
      let indi2 = this.digitsArray.indexOf(lastLetter);
      let nextLetter = '';
      if (indi1 != -1 && lastLetter != 'Z') {
        nextLetter = this.alphabetsArray[indi1 + 1];
      } else if (lastLetter == 'Z') {
        let short_modify = grpName.charAt(grpName.length + PAD_OFFSET)
        let indi3 = this.alphabetsArray.indexOf(short_modify);
        let indi4 = this.digitsArray.indexOf(short_modify);
        let newLeter = "";
        if (indi4 != -1 && short_modify != '9') {
          newLeter = this.digitsArray[indi2 + 1];
        } else if (indi1 == -1) {
          newLeter = this.alphabetsArray[0];
        } else if (indi1 != -1) {
          if (short_modify != 'Z') {
            newLeter = this.alphabetsArray[indi3 + 1];
          }
          else {
            newLeter = this.alphabetsArray[0];
          }

        }
        grpName = grpName.slice(0, grpName.length + PAD_OFFSET) + newLeter + this.alphabetsArray[0];
        console.info('grpname', grpName)

      }
      if (lastLetter != 'Z') {
        if (indi2 != -1 && lastLetter != '9') {
          nextLetter = this.digitsArray[indi2 + 1];
        } else if (indi1 == -1) {
          nextLetter = this.alphabetsArray[0];
        }
        grpName = grpName.slice(0, -1);
        grpName = grpName.concat(nextLetter);
      }
      grpName = grpName.split(' ').join('').toUpperCase().substring(0, SIX);
    }
    loopCount++;
    this.supplierService.getGroupIdentifiers(`${this.Config.ApiSupplierUrl}group-identifiers?value=${grpName}&_page=1`).subscribe(data => {
      if (data['pageCount'] == 0) {
        this.disableGrpShortNameLoad = false;
        console.info('Set group short name', grpName, '>>', grpName.length, 'loop cut at', loopCount);
        this.groupShortName = grpName;
        this.disableNext = false;
        this.nextBtnNotVisible = false;
        setTimeout( function () {
          this.ImportCheckNextNew();
        }.bind(this), TWO_THOUSAND_MS)
      } else {
        this.setGroupNameDynamicFn(grpName, 'continue', loopCount, authGrpName, unoModify);
      }
    });
  }
  saveGroupDetails(Group_BvD, GrpName) {
    this.loadingImpsupp = true;
    
    if (!GrpName || GrpName === 'undefined' || GrpName.trim() === '') {
      GrpName = 'UNKNOWN GROUP';
      console.info("[WARNING] Group name was undefined/empty, using default: UNKNOWN GROUP");
    }
    
    GrpName = GrpName ? GrpName.substring(0, SIXTY) : '';
    this.groupNameModel = GrpName;
    let proceedShortName = false;
    console.info("Missing Mandatory Fields Check for Create Group", GrpName, this.groupCategoryModel, this.groupShortName, this.groupShortNameRegExError);
    if (GrpName != '' && GrpName != undefined && this.groupCategoryModel != '' && this.groupCategoryModel != undefined && this.groupShortName != '' && this.groupShortName != undefined && this.groupShortNameRegExError == false) {
      this.groupShortNameError = false;
      this.groupShortNameExistsError = false;
      this.groupNameModelError = false;
      this.groupCategoryModelError = false;
      this.groupCurrentStatus = 'Creating Group';
      this.nextBtnNotVisible = true;
      this.supplierService.getGroupIdentifiers(`${this.Config.ApiSupplierUrl}group-identifiers?value=${this.groupShortName}&_page=1`).subscribe(data0 => {
        if (data0['pageCount'] == 0) {
          proceedShortName = true;
          this.groupShortNameExistsError = false;
        } else {
          this.saveDatas = 'Save';
          this.groupShortNameExistsError = true;
          proceedShortName = false;
        }
        if (proceedShortName) {
          console.info("**** Create Group is Processing ****");
          console.info(`Group BvD ID : ${Group_BvD} Group Name : ${GrpName}`);
          let grpIdentifierKeyId = "";
          let mdmGroupKey = "";
          this.supplierService.getGroupIdentifierKeys(`${this.Config.ApiSupplierUrl}group-identifier-keys`).subscribe((data18: any) => {
            data18['group-identifier-keys'].forEach(element => {
              if (element.name.toLowerCase() == "bvd") {
                grpIdentifierKeyId = element.row_id;
              }
              if (element.name.toLowerCase() == "mdm group") {
                mdmGroupKey = element.row_id;
              }
            });
            var StartDates = this.apiService.getTodayDate();
            this.groupNameModel = this.groupNameModel.substring(0, SIXTY);
            const datas = { name: this.groupNameModel, groupTypes: this.groupCategoryModel, modificationStatus: 'VALIDATED', startDate: StartDates };
            this.supplierService.createGroups(`${this.Config.ApiSupplierUrl}groups`, datas).subscribe((dataGroup: any) => {
              console.info(`New Group ID is : ${dataGroup['row_id']}`);
              this.createdGroupBvdIds.add(Group_BvD);
              this.groupIdHolder = dataGroup['row_id'];
              this.groupShortName = this.groupShortName.substring(0, SIX);
              const datas2 = {
                "groupId": dataGroup['row_id'],
                "value": this.groupShortName,
                "groupIdentifierKeyId": mdmGroupKey,
                "startDate": StartDates
              }
              this.supplierService.CreateGroupIdentifiers(`${this.Config.ApiSupplierUrl}group-identifiers`, datas2).subscribe(_data => {

                });
              this.supplierService.getApprovalScopes(`${this.Config.ApiSupplierUrl}approval-scopes?code=prospect`).subscribe((data: any) => {
                this.commodityCodeScopeRowid = data['approval-scopes'][0]['row_id'];

                if (this.commodityCodeScopeRowid != '' && this.groupCommodityCodeModel != '' && this.commodityCodeScopeRowid != '') {
                  const datas3 = { groupPwo: `SupPurchasingWorkingOrganizationService:${this.groupCommodityCodeModel}`, groupId: dataGroup['row_id'], scopeId: this.commodityCodeScopeRowid, type: 'GROUP', scopeCode: 'Prospect', approvalModificationStatus: 'VALIDATED', validityStartDate: StartDates };
                  this.supplierService.CreateGroupApprovals(`${this.Config.ApiSupplierUrl}group-approvals`, datas3).subscribe((_dataGApprovals: any) => {

                  });
                }
              });
              if(this.createdCompanyBvdIds.has(this.NL_HQ_BVD_ID_NUMBER)){
                console.info("[DUPLICATE PREVENTION] Company already created for BVD:", this.NL_HQ_BVD_ID_NUMBER);
              }else{
                console.info("**** Create Group DONE ****");
                // Use NL_GUO_BvDdata if available to ensure correct GUO tax identifiers
                const guoBvdData = this.NL_GUO_BvDdata && this.NL_GUO_BvDdata['BVD_ID_NUMBER'] ? this.NL_GUO_BvDdata : this.BvDdata;
                this.saveCompanyDetails(this.groupNameModel, guoBvdData['NATIONAL_ID'], dataGroup['row_id'], Group_BvD, 'Y', guoBvdData['NATIONAL_ID_LABEL'], 'N', 'N', guoBvdData);
              }
            });
          });
        } else {
          this.loadingImpsupp = false;
          this.nextBtnNotVisible = false;
          this.disableNext = false;
          setTimeout( function () {
          this.ImportCheckNextNew();
        }.bind(this), TWO_THOUSAND_MS)
        }
      });
    } else {
      this.loadingImpsupp = false;
      console.info("Missing Mandatory Fields so retrying");
      const currentRetry = Number.isFinite(Number(this.retry)) ? Number(this.retry) : 0;
      if (currentRetry <= 1) {

        this.retry = currentRetry + 1;
        setTimeout( function () {
          this.ImportCheckNextNew();
        }.bind(this), TWO_THOUSAND_MS)
      } else {
        this.groupLinkError = ' Missing Group Name or Category or Short Name ';
        this.checkConditionAndNotify2()
      }
      if (this.groupShortName == '') {
        this.groupShortNameError = true;
      }
      if (this.groupCategoryModel == '') {
        this.groupCategoryModelError = true;
      }
    }
  }
  getCpyShortNameTypes(page = 1) {
    this.supplierService.getCompanyNameTypes(`${this.Config.ApiSupplierUrl}company-name-types?_page=${page}`).subscribe(data => {

      data['company-name-types'].forEach(ele => {
        this.cpyShortNameTypes[ele.name] = ele.row_id;
      });
      if (data['maxPage'] > 1 && data['maxPage'] != page) {
        this.getCpyShortNameTypes(page + 1);
      }
    });
  }
  saveCompanyDetails(cmpName: string, cmpMainTaxId, groupId, BvdforComP, RepresentCompany, cmpMainTaxIdLabel, fromCnS = 'N', fromSpCase = 'N', bvdDataOverride: any = null) {
    this.groupCurrentStatus = 'Creating Company';
    this.nextBtnNotVisible = true;
    
    // Use bvdDataOverride if provided, otherwise fall back to this.BvDdata
    const effectiveBvDdata = bvdDataOverride || this.BvDdata;
    console.info("[FIX] saveCompanyDetails using BVD data for:", effectiveBvDdata['BVD_ID_NUMBER']);
    
    if (!cmpName || cmpName === 'undefined' || cmpName.trim() === '') {
      cmpName = 'UNKNOWN COMPANY';
      console.info("[WARNING] Company name was undefined/empty, using default: UNKNOWN COMPANY");
    }
    
    if (cmpName != '' && cmpName != undefined) {
      this.AllCompanyIdentifierTypes();
      this.companyStatusRowid = "";
      console.info("**** Create Company is Processing ****");
      console.info(`Company Name : ${cmpName} Main TaxID : ${cmpMainTaxId} Group ID : ${groupId} BvDID for Company${BvdforComP}`);

      var cmpNameTypeID = "";
      this.supplierService.getCompanyNameTypes(`${this.Config.ApiSupplierUrl}company-name-types`).subscribe((data18: any) => {
        console.info("company-name-types", data18);
        data18['company-name-types'].forEach(element => {
          if (element.name.toLowerCase() == "short name") {
            cmpNameTypeID = element.row_id;
          }
        });
      });

      var StartDates = this.apiService.getTodayDate();
      this.supplierService.getCompanySatus(`${this.Config.ApiSupplierUrl}company-status`).subscribe((data: any) => {
        data['company-status'].forEach(element => {
          if (element.code.toLowerCase() == "identified") {
            this.companyStatusRowid = element.row_id
          }
        });
        if (this.companyStatusRowid != '' && this.typeName == "bop" ) {
          cmpName = cmpName.substring(0, SIXTY);
          const datas = { legalName: cmpName, companyStatusId: this.companyStatusRowid, companyStatusCode: 'Identified', startDate: StartDates };
          this.supplierService.createCompany(`${this.Config.ApiSupplierUrl}companies?noMdm=1`, datas).subscribe((dataGroup: any) => {
            console.info(`Created new Company ID is : ${dataGroup['rowId']}`);
            this.createdCompanyBvdIds.add(BvdforComP);
            this.latestCompanyId = dataGroup['rowId'];
            if(BvdforComP== this.NL_BVD_ID_NUMBER || BvdforComP == this.NL_HQ_BVD_ID_NUMBER){
            let datas = {
              "companyNameTypeName": "SUPPLIER ACTIVITY",
              "companyId": this.latestCompanyId,
              "endDate": "",
              "companyNameTypeId": "6",
              "value": 'B#BOP',
              "startDate": this.apiService.getTodayDate(),
            }
            this.supplierService.CreateCompanyNames(`${this.Config.ApiSupplierUrl}company-names`,datas).subscribe((_data: any) => {})
          }
          if (this.financeType2 != '') {
          let financetype = `B#${this.financeType2}`;
          let dataType = {
            "companyNameTypeName": "SUPPLIER ACTIVITY",
            "companyId": this.latestCompanyId,
            "endDate": "",
            "companyNameTypeId": "6",
            "value": financetype,
            "startDate": this.apiService.getTodayDate(),
          };
          
            this.supplierService.CreateCompanyNames(`${this.Config.ApiSupplierUrl}company-names`, dataType).subscribe(_data=>{})
        }
          if (this.typeName != "") {
            this.GroupSelectDisab = true;
          }
            // CRITICAL FIX: Always update companyRowId after creating company to prevent linking sites to wrong company
            this.companyRowId = dataGroup['rowId'];
            console.info('[FIX] Updated companyRowId to newly created company:', this.companyRowId);
            if (cmpMainTaxId && cmpMainTaxId.length > 0 && cmpMainTaxId != '') {

              var x = 0;
              console.info("this.IdenKeywithId", this.IdenKeywithId);
              cmpMainTaxId.forEach(element => {
                if (cmpMainTaxIdLabel[x] != null && element != null) {
                  var mainTaxRowid = "";
                  console.info("CMT", cmpMainTaxIdLabel[x]);
                  mainTaxRowid = this.IdenKeywithId[cmpMainTaxIdLabel[x].toLowerCase()];
                  console.info(mainTaxRowid);
                  if (mainTaxRowid != undefined && mainTaxRowid != "" && (cmpMainTaxIdLabel[x].toLowerCase() == 'european vat number')) {
                    element = element.substring(0, TWENTY);
                    var datas21 = { linkedCompanyId: dataGroup['rowId'], companyIdentifierTypeId: mainTaxRowid, value: element.replace(" ", ""), startDate: StartDates };
                    this.supplierService.createCompanyIdentifiers(`${this.Config.ApiSupplierUrl}company-identifiers`, datas21).subscribe((_dataGApprovals: any) => {
                    });
                  }
                }
                x++;
              });
            }
            let shortName = cmpName.split(' ').join('');
            if (shortName.length <= TEN) {
              shortName = shortName.padEnd(TEN);
            } else if (shortName.length > TEN) {
              shortName = shortName.slice(0, TEN);
            }
            shortName = shortName.substring(0, TEN);
            this.cmpShortName=shortName
            const datas3 = { companyId: dataGroup['rowId'], companyNameTypeId: this.cpyShortNameTypes['SHORT NAME'], "value": shortName, startDate: StartDates }
            this.supplierService.CreateCompanyNames(`${this.Config.ApiSupplierUrl}company-names`, datas3).subscribe((_data: any) => {

            })
            let today = new Date();
            let dd = String(today.getDate()).padStart(TWO, '0');
            let mm = String(today.getMonth() + 1).padStart(TWO, '0'); //January is 0!
            let yyyy = today.getFullYear();
            let todayDate = `${yyyy}-${mm}-${dd}`;
            const datas5 = {
              "apoStatus": "ACTIVE",
              "companyId": dataGroup['rowId'],
              "groupTypeCode": "",
              "groupId": groupId,
              "validityStartDate": todayDate,
              "status": "VALIDATED",
              "groupTypeId": TWO
            };
            this.groupCurrentStatus = 'Creating Group Assignment';
            this.nextBtnNotVisible = true;
            this.supplierService.CreateGroupAssignment(`${this.Config.ApiSupplierUrl}group-assignments`, datas5).subscribe((_data: any) => {
              this.saveDatas = "Save";
              var BvDAssign = this.sveCompanies;
              console.info("**** Create Company Done ****");
              if (fromCnS == "Y") {
                console.info("Company Module");
                if (fromSpCase == 'Y') {
                  console.info('NL_BvDdataCnS', this.NL_BvDdataCnS);
                  console.info('effectiveBvDdata', effectiveBvDdata);
                  // Check BvdforComP instead of NL_BVD_ID_NUMBER for proper duplicate prevention
                  if (this.createdSiteBvdIds.has(BvdforComP)) {
                    console.info("[DUPLICATE PREVENTION] Site already created for BVD:", BvdforComP);
                  } else {
                    let city = this.apiService.hasNoSpecialCharacters(effectiveBvDdata['CITY_STANDARDIZED'], effectiveBvDdata['CITY']);
                    this.saveSitesDetails(cmpName, effectiveBvDdata['COUNTRY'], effectiveBvDdata['COUNTRY_ISO_CODE'], city, effectiveBvDdata['POSTCODE'], dataGroup['rowId'], BvdforComP, fromCnS, effectiveBvDdata,'');
                  }
                } else {
                 // Check BvdforComP instead of NL_BVD_ID_NUMBER for proper duplicate prevention
                 if (this.createdSiteBvdIds.has(BvdforComP)) {
                    console.info("[DUPLICATE PREVENTION] Site already created for BVD:", BvdforComP);
                  } else {
                    let city = this.apiService.hasNoSpecialCharacters(effectiveBvDdata['CITY_STANDARDIZED'], effectiveBvDdata['CITY']);
                    this.saveSitesDetails(cmpName, effectiveBvDdata['COUNTRY'], effectiveBvDdata['COUNTRY_ISO_CODE'], city, effectiveBvDdata['POSTCODE'], dataGroup['rowId'], BvdforComP, fromCnS, effectiveBvDdata,'');
                  }
                }
              } else {
                  // Check BvdforComP instead of NL_BVD_ID_NUMBER for proper duplicate prevention
                  if (this.createdSiteBvdIds.has(BvdforComP)) {
                    console.info("[DUPLICATE PREVENTION] Site already created for BVD:", BvdforComP);
                  } else {
                    let city = this.apiService.hasNoSpecialCharacters(effectiveBvDdata['CITY_STANDARDIZED'], effectiveBvDdata['CITY']);
                    this.saveSitesDetails(cmpName, effectiveBvDdata['COUNTRY'], effectiveBvDdata['COUNTRY_ISO_CODE'], city, effectiveBvDdata['POSTCODE'], dataGroup['rowId'], BvdforComP, fromCnS, effectiveBvDdata,'');
                  }
              }
              this.groupMdmSwitch = true
              console.info("**** Create Company Done ****");

            });

            if (RepresentCompany == "Y") {
              const const1 = { representingCompanyId: dataGroup['rowId'] }
              this.supplierService.UpdateGroups(`${this.Config.ApiSupplierUrl}groups/${groupId}`, const1).subscribe(_data => {
              });
            }
          });
        }
        else if(this.companyStatusRowid != '' && (this.typeName == 'nbop' || this.typeName == 'finance')) {
          let type = this.typeName == 'nbop' ? 'B#NBOP' : 'B#FINANCE' 
          cmpName = cmpName.substring(0,SIXTY);
          const datas = {legalName:cmpName, companyStatusId: this.companyStatusRowid, companyStatusCode:'Identified', startDate:StartDates };
          this.supplierService.createCompany(`${this.Config.ApiSupplierUrl}companies?noMdm=1`, datas).subscribe((dataGroup:any) => {
            console.info(`Created new Company ID is : ${dataGroup['rowId']}`);
            this.createdCompanyBvdIds.add(BvdforComP);
            this.latestCompanyId = dataGroup['rowId'];
            this.GroupSelectDisab = true;
            if(BvdforComP == this.NL_BVD_ID_NUMBER || BvdforComP == this.NL_HQ_BVD_ID_NUMBER){
            let datas = {
              "companyNameTypeName": "SUPPLIER ACTIVITY",
              "companyId": this.latestCompanyId,
              "endDate": "",
              "companyNameTypeId": "6",
              "value": type,
              "startDate": this.apiService.getTodayDate(),
            }
            this.supplierService.CreateCompanyNames(`${this.Config.ApiSupplierUrl}company-names`,datas).subscribe((_data: any) => {})
          }
          // CRITICAL FIX: Always update companyRowId after creating company to prevent linking sites to wrong company
          this.companyRowId = dataGroup['rowId'];
          console.info('[FIX] Updated companyRowId to newly created company:', this.companyRowId);
          if(!(fromCnS=="Y" || this.NL_Case_Occur==SEVEN)) {
              this.GroupSelectDisab = false;
            }
            if(cmpMainTaxId && cmpMainTaxId.length>0 && cmpMainTaxId != ''){
              
              var x=0;
              console.info("this.IdenKeywithId",this.IdenKeywithId);
              cmpMainTaxId.forEach(element => {
                if(cmpMainTaxIdLabel[x] != null && element != null){
                  var mainTaxRowid="";
                  console.info("CMT",cmpMainTaxIdLabel[x]);
                  mainTaxRowid = this.IdenKeywithId[cmpMainTaxIdLabel[x].toLowerCase()];
                  console.info(mainTaxRowid);
                  if(mainTaxRowid!=undefined && mainTaxRowid!="" && (cmpMainTaxIdLabel[x].toLowerCase()=='european vat number')) {
                    element = element.substring(0,TWENTY);
                    var datas21 = {linkedCompanyId:dataGroup['rowId'], companyIdentifierTypeId:mainTaxRowid, value: element.replace(" ", ""),startDate:StartDates};
                    this.supplierService.createCompanyIdentifiers(`${this.Config.ApiSupplierUrl}company-identifiers`,datas21).subscribe((_dataGApprovals:any) => {
                    });
                  }
                }
                x++;
              });
            }
            let shortName = cmpName.split(' ').join('');
            if(shortName.length <=TEN){
              shortName = shortName.padEnd(TEN);
            }else if(shortName.length > TEN){
              shortName = shortName.slice(0,TEN);
            }
            shortName = shortName.substring(0,TEN);
            this.cmpShortName=shortName
            const datas3 = { companyId : dataGroup['rowId'], companyNameTypeId: this.cpyShortNameTypes['SHORT NAME'], "value" : shortName, startDate: StartDates }
            this.supplierService.CreateCompanyNames(`${this.Config.ApiSupplierUrl}company-names`, datas3).subscribe( (_data: any) => {
              
            })
            let today = new Date();
            let dd = String(today.getDate()).padStart(TWO, '0');
            let mm = String(today.getMonth() + 1).padStart(TWO, '0'); //January is 0!
            let yyyy = today.getFullYear();
            let todayDate = `${yyyy}-${mm}-${dd}`;
            const datas5 = {
              "apoStatus" : "ACTIVE",
              "companyId" : dataGroup['rowId'],
              "groupTypeCode" : "",
              "groupId" : groupId,
              "validityStartDate" : todayDate,
              "status" : "VALIDATED",
              "groupTypeId": TWO
            };
            this.groupCurrentStatus = 'Creating Group Assignment';
            this.nextBtnNotVisible=true;
            this.supplierService.CreateGroupAssignment(`${this.Config.ApiSupplierUrl}group-assignments`, datas5).subscribe((_data:any) => {
              this.saveDatas = "Save";
              var BvDAssign = this.sveCompanies;
              console.info("**** Create Company Done ****");
              console.info('NL_BvDdataCnS',this.NL_BvDdataCnS);
              console.info('effectiveBvDdata',effectiveBvDdata);
              console.info('bvd',this.sveCompanies)
              if(fromCnS=="Y") {
                console.info("Company Module");
                if(fromSpCase == 'Y'){
                  
                  // Check BvdforComP instead of NL_BVD_ID_NUMBER for proper duplicate prevention
                  if (this.createdSiteBvdIds.has(BvdforComP)) {
                    console.info("[DUPLICATE PREVENTION] Site already created for BVD:", BvdforComP);
                  } else {
                    let city = this.apiService.hasNoSpecialCharacters(effectiveBvDdata['CITY_STANDARDIZED'], effectiveBvDdata['CITY']);
                    this.saveSitesDetails(cmpName, effectiveBvDdata['COUNTRY'], effectiveBvDdata['COUNTRY_ISO_CODE'], city, effectiveBvDdata['POSTCODE'], dataGroup['rowId'], BvdforComP, fromCnS, effectiveBvDdata,'');
                  }
                }else{
                  // Check BvdforComP instead of NL_BVD_ID_NUMBER for proper duplicate prevention
                  if (this.createdSiteBvdIds.has(BvdforComP)) {
                    console.info("[DUPLICATE PREVENTION] Site already created for BVD:", BvdforComP);
                  } else {
                    let city = this.apiService.hasNoSpecialCharacters(this.NL_BvDdataCnS['CITY_STANDARDIZED'], this.NL_BvDdataCnS['CITY']);
                    this.saveSitesDetails(cmpName, this.NL_BvDdataCnS['COUNTRY'], this.NL_BvDdataCnS['COUNTRY_ISO_CODE'], city, this.NL_BvDdataCnS['POSTCODE'], dataGroup['rowId'], BvdforComP, fromCnS, this.NL_BvDdataCnS,'');
                  }
                }
              } else {
                console.info("Group Module"); 
                  // Check BvdforComP instead of NL_BVD_ID_NUMBER for proper duplicate prevention
                  if (this.createdSiteBvdIds.has(BvdforComP)) {
                    console.info("[DUPLICATE PREVENTION] Site already created for BVD:", BvdforComP);
                  } else {
                    let city = this.apiService.hasNoSpecialCharacters(effectiveBvDdata['CITY_STANDARDIZED'], effectiveBvDdata['CITY']);
                    this.saveSitesDetails(cmpName, effectiveBvDdata['COUNTRY'], effectiveBvDdata['COUNTRY_ISO_CODE'], city, effectiveBvDdata['POSTCODE'], dataGroup['rowId'], BvdforComP, fromCnS, effectiveBvDdata,'');
                  }
              }
              this.groupMdmSwitch = false
              console.info("**** Create Company Done ****");
              
            });
            
            if(RepresentCompany=="Y") {
              const const1 = {representingCompanyId : dataGroup['rowId']}
              this.supplierService.UpdateGroups(`${this.Config.ApiSupplierUrl}groups/${groupId}`, const1).subscribe(_data => {
              });
            }
          });   
        }
      });

    }
  }

  saveSitesDetails(CmpName, counName, counCode, CityName, Postal, CompanayID, BvDidforsite, fromCnS = "N", thisBvDdata: any = [],from='', times = 1, counFilter = 'none') {
    console.info("[DEBUG] saveSitesDetails STARTED - ImportDone:", this.ImportDone, "fromCnS:", fromCnS);
    console.info("thisBvDdata", thisBvDdata);
    this.createdSiteBvdIds.add(BvDidforsite); // Mark as being created immediately
    console.info("[DUPLICATE PREVENTION] Marked BVD for site creation:", BvDidforsite);
    
    if (!CmpName || CmpName === 'undefined' || CmpName.trim() === '') {
      CmpName = 'UNKNOWN COMPANY';
      console.info('[WARNING] Company name was undefined/empty, using default: UNKNOWN COMPANY');
    }
    
    console.info("**** Create Site Processing ****");
    console.info(`Site Name : ${CmpName} ${CityName} Country : ${counName} CountryCode : ${counCode} City Name :${CityName} Postal : ${Postal} Company ID${CompanayID} BvD for Site${BvDidforsite}`);
    console.info('debug>>', this.CountryNameKeyId);
    this.groupCurrentStatus = 'Creating Site';
    this.nextBtnNotVisible = true;

    this.selectedCountry = counName;
    if (CityName == undefined || CityName == '' || CityName == null) {
      CityName = 'UNKNOWN';
      console.info('changing city to unknown');
    }

    if (this.CountryNameKeyId[counCode] == undefined && times < TWO && counName != null && counName != '' && counFilter != 'yes') {
      console.info('No country id found, search in list and retry....');
      this.countryService.getCountries(`${this.Config.ApiCountryUrl}countries?countryCode=${counCode}&_page=1`).subscribe((data: any) => {
        if (data['count'] > 0) {
          data['countries'].forEach(element => {
            let captain_exist = this.CaptCountry.indexOf(element.countryName);
            let captain_exist1 = this.countrySelList.indexOf(element.countryName);
            if (captain_exist == -1) {
              let obj = {};
              obj['countryCode'] = element['countryCode'];
              obj['countryName'] = element['countryName'];
              obj['rowId'] = element['rowId'];
              this.CountryNameKeyId[element.countryCode] = obj;
            }
            if (captain_exist1 == -1) {
              this.countrySelList.push(`${element.countryCode} - ${element.countryName}`);
            }
          });
        }
        this.saveSitesDetails(CmpName, counName, counCode, CityName, Postal, CompanayID, BvDidforsite, fromCnS, thisBvDdata,'', times + 1);
        this.selectedCountry = counName;

        this.tempVarCounList['CmpName'] = CmpName;
        this.tempVarCounList['counName'] = counName;
        this.tempVarCounList['CityName'] = CityName;
        this.tempVarCounList['Postal'] = Postal;
        this.tempVarCounList['CompanayID'] = CompanayID;
        this.tempVarCounList['BvDidforsite'] = BvDidforsite;
        this.tempVarCounList['fromCnS'] = fromCnS;
        this.tempVarCounList['thisBvDdata'] = thisBvDdata;
        this.tempVarCounList['times'] = times;
      });
    } else if (this.CountryNameKeyId[counCode] == undefined && times == TWO && counFilter != 'yes' && this.countrySelList.length > 1) {
      console.info('tempVarCounList', this.tempVarCounList);
      document.getElementById('btnForSelectCountryId').click();
    } else {
      if(counCode == undefined || counCode == null || counCode == '') {
        counCode = 'CC'
      }
      this.countryService.getCountries(`${this.Config.ApiCountryUrl}countries?countryCode=${counCode}&_page=1`).subscribe((data: any) => {
         if (data['count'] > 0) {
          data['countries'].forEach(element => {
            let captain_exist = this.CaptCountry.indexOf(element.countryName);

            if (captain_exist == -1) {
              let obj = {};
              obj['countryCode'] = element['countryCode'];
              obj['countryName'] = element['countryName'];
              obj['rowId'] = element['rowId'];
              this.CountryNameKeyId[element.countryCode] = obj;
            }
          })
        }
      const country = this.CountryNameKeyId[counCode];
      const countryId = country?.rowId ?? '';
      this.selectedCountry = country?.countryName ?? '';

      const cityS = thisBvDdata ? (thisBvDdata['CITY_STANDARDIZED'] ?? '') : '';
      const cityParam = thisBvDdata ? (thisBvDdata['CITY'] ?? CityName) : CityName;
      this.apiService.cityCreationOptimization(cityS, cityParam, counCode,countryId).subscribe((cityObj: any) => {
        const resolvedCityName = cityObj?.name ?? CityName;
        const cityId = cityObj?.rowId;
        if (cityId) {
          this.saveSiteInformation(
            countryId,
            cityId,
            CmpName,
            resolvedCityName,
            Postal,
            CompanayID,
            BvDidforsite,
            fromCnS,
            thisBvDdata,
            from
          );
        }
      }, error => {
        const errorMessage = error?.message ?? error?.error ?? error?.status ?? 'City creation failed';
        this.groupLinkError = ` City creation failed for ${BvDidforsite}: ${JSON.stringify(errorMessage)}`;
        this.checkConditionAndNotify2();
      });
    })
    }
  
  }

  saveSiteInformation(countryId, cityId, CmpName: string, CityName: string, Postal = '', CompanayID, BvDidforsite, fromCnS = "N", thisBvDdata: any = [], from = '') {
    console.info("thisBvDdata2", thisBvDdata);
    this.SiteRowID = "";
    const siteDatas = {
      cityId: cityId,
      countryId: countryId,
      activeStatus: "CREATED",
      name: `${CmpName} ${CityName}`,
      usualName: `${this.cmpShortName} ${CityName}`,
      effectiveDate: this.apiService.getTodayDate(),
      "irnAuthor": "IRN-71016",
      "siaAuthor": "IAF",
      "isMergingSite": this.varIsMergingSite,
    };
    console.info("CNSVAlue", fromCnS);
    this.siteService.createSite(`${this.Config.ApiSitesUrl}sites`, siteDatas).subscribe((dataSite: any) => {
      var site_row_id = dataSite["rowId"];
      this.createdSite.push(site_row_id);
      this.createdSiteBvdIds.add(BvDidforsite);
      // const constSiteStatus = { "activeStatus": "CREATED" }
      // this.siteService.updateSite(`${this.Config.ApiSitesUrl}sites/${site_row_id}`, constSiteStatus).subscribe(() => {

      // }, error => {
      //   console.error('[BVD IMPORT SERVICE] Failed to force site status to CREATED for site:', site_row_id, error);
      // });
      console.info(`Created New site ID is : ${dataSite["rowId"]}`);
      if (this.NL_Case_Occur == SEVEN || fromCnS == "S" || fromCnS == 'W' || fromCnS=='Y') {
        this.SiteRowID = dataSite["rowId"];
      }
      const accessPDatas = {
        activeStatus: "ACTIVE",
        realEstateAssetId: site_row_id,
        type: "P14",
        activity:'A10',
        label: CmpName,
        effectiveDate: this.apiService.getTodayDate(),
        "irnAuthor": "IRN-71016",
        "siaAuthor": "IAF"
      };
      this.groupCurrentStatus = 'Creating Access Points';
      this.nextBtnNotVisible = true;
      this.siteService.createAccessPoint(`${this.Config.ApiSitesUrl}access-points`, accessPDatas).subscribe((dataAccessP: any) => {
        let access_point_row_id = dataAccessP["rowId"];
        let addinfo = "";
        if (thisBvDdata['ADDRESS_LINE1'] == undefined || thisBvDdata['ADDRESS_LINE1'] == '' || thisBvDdata['ADDRESS_LINE1'] == null) {
          thisBvDdata['ADDRESS_LINE1'] = 'UNKNOWN';
          console.info('street is null changing to unknown');
        }
        console.info("ADDRESS_LINE1", thisBvDdata['ADDRESS_LINE1']);
        thisBvDdata['ADDRESS_LINE1'] = thisBvDdata['ADDRESS_LINE1'].substring(0, THIRTY_FIVE);
        if (thisBvDdata['ADDRESS_LINE2'] != null && thisBvDdata['ADDRESS_LINE2'] != "") {
          addinfo += `${thisBvDdata['ADDRESS_LINE2']} `;
        }
        if (thisBvDdata['ADDRESS_LINE3'] != null && thisBvDdata['ADDRESS_LINE2'] != "") {
          addinfo += thisBvDdata['ADDRESS_LINE3'];
        }
        let geoADatas = {};
        if (thisBvDdata['ADDRESS_LINE1'] == null) {
          thisBvDdata['ADDRESS_LINE1'] = "";
        }
        addinfo = addinfo.substring(0, ONE_HUNDRED_SEVEN);
        if (Postal != '' && Postal != null) {
          Postal = Postal.substring(0, NINE);
          geoADatas = {
            additionalInformation: addinfo,
            streetName: thisBvDdata['ADDRESS_LINE1'],
            postalCode: Postal,
            cityId: cityId,
            countryId: countryId,
            "irnAuthor": "IRN-71016",
            "siaAuthor": "IAF"
          };
        } else {
          geoADatas = {
            additionalInformation: addinfo,
            streetName: thisBvDdata['ADDRESS_LINE1'],
            cityId: cityId,
            countryId: countryId,
            "irnAuthor": "IRN-71016",
            "siaAuthor": "IAF"
          };
        }
        this.groupCurrentStatus = 'Creating Addresses';
        this.nextBtnNotVisible = true;
        this.addressService.createGeographicalAddresses(`${this.Config.ApiAddressUrl}geographical-addresses`, geoADatas).subscribe((dataGeoA: any) => {
          var geo_adress_row_id = dataGeoA["rowId"];
          const accessPointDatas = {
            accessPointId: access_point_row_id,
            addressId: geo_adress_row_id
          };
          this.accessPointDatas1 = geo_adress_row_id
          this.siteService.createAccessPointAddress(`${this.Config.ApiSitesUrl}access-points-addresses`, accessPointDatas).subscribe((_dataAccessPoint: any) => {
            let accessPointDatas
            if(this.c2bName!='' && this.NL_BVD_ID_NUMBER==BvDidforsite){
              accessPointDatas = 
                {
                  activeStatus: "PENDING",
                  realEstateAssetId: site_row_id,
                  type: "P11",
                  activity:'A10',
                  label: CmpName,
                  effectiveDate: this.apiService.getTodayDate(),
                  "irnAuthor": "IRN-71016",
                  "siaAuthor": "IAF"
                }
            this.siteService.createAccessPoint(`${this.Config.ApiSitesUrl}access-points`, accessPointDatas).subscribe((dataAccessP: any) => {
              let data = {}
            if(dataAccessP['type']=="P11"){
              this.siteService.getIdentifierTypes(`${this.Config.ApiSitesUrl}identifier-types?name=AP_C2B_CODE`).subscribe(data1 => {
                this.siteService.getSourceSystems(`${this.Config.ApiSitesUrl}source-systems?name=C2B`).subscribe(data2 => {
                data={
                "sourceSystemId": data2['source-systems'][0]['rowId'],
                "siteIdentifier":dataSite['identifier'],
                "identifierValue":this.c2bName,
                "identifierId": data1['identifier-types'][0]['rowId'],
                "sourceSystemName": "C2B",
                "accessPointRowId":dataAccessP['rowId'],
                "effectiveDate":this.apiService.getTodayDate(),
                "accessPointType": "P11",
                "identifierTypeName": "AP_C2B_CODE"
              }
              this.siteService.createAccessPointIdentifier(`${this.Config.ApiSitesUrl}access-point-identifiers`,data).subscribe(_data =>{
                const accessPointDatas = {accessPointId:dataAccessP['rowId'], addressId: this.accessPointDatas1};
                  this.siteService.createAccessPointAddress(`${this.Config.ApiSitesUrl}access-points-addresses`, accessPointDatas).subscribe((_dataAccessPoint:any) => {

                  })
                  if ((thisBvDdata['LATITUDE'] != '' && thisBvDdata['LATITUDE'] != null) || (thisBvDdata['LONGITUDE'] != '' && thisBvDdata['LONGITUDE'] != null)) {
                    const accessPointDatas2 = {
                      accessPointId: dataAccessP['rowId'],
                      addressId: this.accessPointDatas3
                    };
                    this.siteService.createAccessPointAddress(`${this.Config.ApiSitesUrl}access-points-addresses`, accessPointDatas2).subscribe((_dataAccessPoint: any) => {

                    });
                  }
              })
            })
          })
            }
          })
        }
          });

          if ((thisBvDdata['LATITUDE'] != '' && thisBvDdata['LATITUDE'] != null) || (thisBvDdata['LONGITUDE'] != '' && thisBvDdata['LONGITUDE'] != null)) {
            const gpsDatas = { 'accessPointId': access_point_row_id, 'latitude': thisBvDdata['LATITUDE'] ? thisBvDdata['LATITUDE'].toString() : "", 'longitude': thisBvDdata['LONGITUDE'] ? thisBvDdata['LONGITUDE'].toString() : "" }
            console.info("gpsDatas", gpsDatas);
            this.addressService.createGeolocationCoordinatesAddresses(`${this.Config.ApiAddressUrl}geolocation-coordinates-addresses`, gpsDatas).subscribe((dataGeoA: any) => {
              console.info("geolocation-coordinates-addresses : ", dataGeoA);
              const accessPointDatas2 = {
                accessPointId: access_point_row_id,
                addressId: dataGeoA['rowId']
              };
              this.accessPointDatas3=dataGeoA['rowId']
              this.siteService.createAccessPointAddress(`${this.Config.ApiSitesUrl}access-points-addresses`, accessPointDatas2).subscribe((_dataAccessPoint: any) => {

              });
            });
          }
          if(from == 'importDone'){
          this.checkConditionAndNotify()
        }
        });
      });
    this.addSiteCategoryToAssignment(site_row_id, CompanayID, BvDidforsite, `${CmpName} ${CityName}`, fromCnS, thisBvDdata);


    });
  }
  addSiteCategoryToAssignment(site_row_id, CompanayID, BvDidforsite, Site_Name, fromCnS = "N", thisBvDdata: any = []) {
    this.groupCurrentStatus = 'Creating Assignments';
    this.nextBtnNotVisible = true;
    const newCategory = { "realEstateAssetId": site_row_id, "categoryId": this.newCategoryAssignment, "categoryName": this.newCategoryName }
    this.siteService.createRealEstateAssetAssignment(`${this.Config.ApiSitesUrl}real-estate-asset-assignments`, newCategory).subscribe(_data012 => {

    });
    this.supplierService.getSiteAssignments(`${this.Config.ApiSupplierUrl}site-assignments?site=SupSiteService:${site_row_id}&_page=1&status=VALIDATED`).subscribe(data => {
      if (data['pageCount'] == 1) {
        if (data['site-assignments'][0]['status'] == 'VALIDATED') {
          this.businessEntityIdSite = data['site-assignments'][0]['businessEntityId'];
          this.addTaxIdentifiers(BvDidforsite, site_row_id, thisBvDdata);

          console.info("SRifalse1");

        } else {
          console.info("SRitrue1");

          this.changeCompanySiteAssnNoExist(site_row_id, CompanayID, BvDidforsite, Site_Name, fromCnS, thisBvDdata);
        }
      } else if (data['pageCount'] > 1) {
        this.businessEntityIdSite = data['site-assignments'][0]['businessEntityId'];
        this.addTaxIdentifiers(BvDidforsite, site_row_id, thisBvDdata);

        console.info("SRifalse2");
      } else {

        console.info("SRitrue2");
        this.changeCompanySiteAssnNoExist(site_row_id, CompanayID, BvDidforsite, Site_Name, fromCnS, thisBvDdata);
      }
    });
  }
   AllgroupCategories(page = 1, subscribeData = []) {
    this.groupCategories = [];
    this.supplierService.getGroupTypes(`${this.Config.ApiSupplierUrl}group-types?_page=${page}`).subscribe((data2: any) => {
      if (data2['group-types'] && data2['group-types'] != null) {
        data2['group-types'].forEach(element => {
          subscribeData.push(element);
        });
      }
      if (data2['maxPage'] > 1 && data2['maxPage'] != page) {
        this.AllgroupCategories(page + 1, subscribeData);
      } else if (data2['maxPage'] == page) {
        this.groupCategories = subscribeData;
        subscribeData.forEach(element => {
          this.groupCategoriesByKey[element.groupTypeCode] = element.row_id;
          if ((element.groupTypeCode) == 'BOP/NBOP' || element.groupTypeCode.toLowerCase() == 'external supplier') {
            this.groupCategoryModel = element.row_id;
          }
        });
      }
    });
  }

  ccbyType(Type, grpID, LoadOff = '') {

    var prospectPwosId = '';
    this.supplierService.getGroups(`${this.Config.ApiSupplierUrl}groups/${grpID}/group-approvals?scopeCode=${Type}&groupPwo.href!=""`).subscribe((data: any) => {
      if (data["group-approvals"] != null && data["group-approvals"].length > 0) {
        console.info('debug1', data['group-approvals']);
        for (let i = 0; i < data['group-approvals'].length; i++) {
          let prospectTypeid = data["group-approvals"][i]['groupPwo'].href.split('/');
          prospectPwosId += `${prospectTypeid[1]},`;
        }
        if (prospectPwosId != '') {
          this.purchasingService.getcommodityPerimeters(`${this.Config.ApiPurchasingUrl}commodity-perimeters?typeCode=Commodity Code&rowId=in(${prospectPwosId.slice(0, -1)})`).subscribe((data1: any) => {
            console.info("this.pagerPanelCurrentPage===>", data1);
            if (data1 && data1 != null) {
              if (Type == "Prospect") {
                var TypeCC = "prospectCC";
              } else if (Type == "In panel") {
                var TypeCC = "panelCC";
              }
              this.GroupBvDdetails[TypeCC] = [];
              if (data1['commodity-perimeters']) {
                data1['commodity-perimeters'].forEach(element => {
                  this.GroupBvDdetails[TypeCC].push(`${element.code} - ${element.label}`);
                });
              }
            }
          });
        }
      }
      if (LoadOff == "loadOff") {
        this.loadingImpsupp = false;
      }
    });
  }
  getCompaniesbyGroupID(GroupId) {
    var curr_page = 1;
    this.supplierService.getGroups(`${this.Config.ApiSupplierUrl}groups/${GroupId}/group-assignments?_page=${curr_page}`).subscribe((data: any) => {
      console.info("Companies", data);
      return data;
    });
  }


  JoinBusniessEntity() {
    this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityIdentifierTypeName=BVD ID&businessEntityId=in(${this.beRowID})`).subscribe(
      (data: any) => {
        if (data['business-entity-identifiers'].length > 0) {
          data['business-entity-identifiers'].forEach(element => {
            if (element.businessEntityIdentifierTypeName.toLowerCase() == "bvd id") {
              this.SiteDe_BvdID_Stat[element.businessEntityId] = element;
            }
          });
        }
      });

  }

  joincityCountry() {
    if (this.SiteRowID.length > 0) {
      this.Site_City_Country = [];
      this.siteService.getSites(`${this.Config.ApiSitesUrl}sites?_page=1&rowId=in(${this.SiteRowID})`).subscribe((data: any) => {
        data['sites'].forEach(element5 => {
          this.Site_City_Country[element5.rowId] = element5;
        });
      });
    }
    this.SiteDispLoading = false;

  }

  JoinQualifiers() {
    if (this.SiteRowID.length > 0) {
      this.site_qualifiers = [];
      this.siteService.getAccessPoints(`${this.Config.ApiSitesUrl}access-points?realEstateAssetId=in(${this.SiteRowID})`).subscribe(
        (data: any) => {
          data['access-points'].forEach(element2 => {
            if (typeof this.site_qualifiers[element2.realEstateAssetId] == 'undefined') {
              this.site_qualifiers[element2.realEstateAssetId] = [];
            }
            if (this.site_qualifiers[element2.realEstateAssetId][element2.type]) {
              var ove = this.site_qualifiers[element2.realEstateAssetId][element2.type];
              this.site_qualifiers[element2.realEstateAssetId][element2.type] = ove + 1;
            }
            else {
              this.site_qualifiers[element2.realEstateAssetId][element2.type] = 1;
            }
          });
          this.SiteDispLoading = false;
        });

    } else {
      this.SiteDispLoading = false;
    }
    console.info('[Retry] end ImportCheckNextNew retry=', this.retry);
  }


  AllCompanyIdentifierTypes2() {
    this.CIdentifierTypes = [];
    this.CIdentifierTypes[0] = 'Alliance Company ID';
    this.supplierService.getCompanyIdentifierKeys(`${this.Config.ApiSupplierUrl}company-identifier-keys`).subscribe((data: any) => {
      if (data['company-identifier-keys'].length > 0) {
        data['company-identifier-keys'].forEach(element => {
          if (element['name'].toLowerCase() != "duns") {
            this.CIdentifierTypes.push(element['name']);
            this.IdenKeywithId[element['name'].toLowerCase()] = element['row_id'];
          }
        });
      }
      this.loading = false;
    }, _error => {
      this.AllCompanyIdentifierTypes2();
    });
  }
  AllCompanyIdentifierTypes() {
    this.CIdentifierTypes = [];
    this.CIdentifierTypes[0] = 'Alliance Company ID';
    this.supplierService.getCompanyIdentifierKeys(`${this.Config.ApiSupplierUrl}company-identifier-keys`).subscribe((data: any) => {
      if (data['company-identifier-keys'].length > 0) {
        data['company-identifier-keys'].forEach(element => {
          if (element['name'].toLowerCase() != "duns") {
            this.CIdentifierTypes.push(element['name']);
            this.IdenKeywithId[element['name'].toLowerCase()] = element['row_id'];
          }
        });
      }
      this.loading = false;
    }, _error => {
      this.AllCompanyIdentifierTypes();
    });
  }
  changeCompanySiteAssnNoExist(siteID, CMPiD, BvDidforsite, Site_Name, fromCnS = "N", thisBvDdata: any = []) {
    // Validate required parameters to prevent 400 Bad Request
    if (!CMPiD || CMPiD === '' || CMPiD === 'undefined' || CMPiD === 'null') {
      console.error("[ERROR] changeCompanySiteAssnNoExist called with empty companyId. siteID:", siteID, "BvDidforsite:", BvDidforsite);
      return;
    }
    var tempBusinessRowId;
    this.groupCurrentStatus = 'Creating BvD for Site';
    this.nextBtnNotVisible = true;
    if (fromCnS == "S") {
      const datas2 = { modificationStatus: "VALIDATED", isHQ: "N", companyId: CMPiD };
      this.supplierService.CreateBusinessEntities(`${this.Config.ApiSupplierUrl}business-entities`, datas2).subscribe((dataGApprovals: any) => {
        tempBusinessRowId = dataGApprovals['row_id'];
        this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityId=${tempBusinessRowId}&_page=1`).subscribe(data1 => {
          if (data1['pageCount'] > 0) {

          }
          else {
            const const2 = {
              "businessEntityIdentifierTypeId": "1",
              "businessEntityIdentifierTypeName": "BVD ID",
              "startDate": this.apiService.getTodayDate(),
              "businessEntityId": tempBusinessRowId,
              "value": BvDidforsite
            }
            this.supplierService.CreateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers`, const2).subscribe(_data2 => {

            });
          }
          const const3 = {
            "validityStartDate": this.apiService.getTodayDate(),
            "status": "VALIDATED",
            "businessEntityId": tempBusinessRowId
          }
          console.info("CNSVAlue", fromCnS);
          this.supplierService.CreateSiteAssignments(`${this.Config.ApiSupplierUrl}site-assignments?site=SupSiteService:${siteID}`, const3).subscribe(data3 => {
            this.businessEntityIdSite = data3.businessEntityId;
            this.addTaxIdentifiers(BvDidforsite, siteID, thisBvDdata);
            this.changeParamsforNewCpy('doesnotexist', siteID, CMPiD, Site_Name, BvDidforsite, fromCnS);
          })
        });
      });
    } else {
      this.supplierService.getBusinessEntities(`${this.Config.ApiSupplierUrl}business-entities?companyId=${CMPiD}&isHQ=Y`).subscribe(data => {
        if (data['business-entities'].length > 0) {
          tempBusinessRowId = data['business-entities'][0]['row_id'];
          this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityId=${tempBusinessRowId}&_page=1`).subscribe(data1 => {
            if (data1['pageCount'] > 0) {

            }
            else {
              const const2 = {
                "businessEntityIdentifierTypeId": "1",
                "businessEntityIdentifierTypeName": "BVD ID",
                "startDate": this.apiService.getTodayDate(),
                "businessEntityId": tempBusinessRowId,
                "value": BvDidforsite
              }
              this.supplierService.CreateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers`, const2).subscribe(_data2 => {

              });
            }
            const const3 = {
              "validityStartDate": this.apiService.getTodayDate(),
              "status": "VALIDATED",
              "businessEntityId": tempBusinessRowId
            }
            console.info("CNSVAlue", fromCnS);
            this.supplierService.CreateSiteAssignments(`${this.Config.ApiSupplierUrl}site-assignments?site=SupSiteService:${siteID}`, const3).subscribe(data3 => {
              this.businessEntityIdSite = data3.businessEntityId;
              this.addTaxIdentifiers(BvDidforsite, siteID, thisBvDdata);
              this.changeParamsforNewCpy('doesnotexist', siteID, CMPiD, Site_Name, BvDidforsite, fromCnS);
            });
          });
        } else {
          const datas = { companyId: CMPiD, isHQ: "Y" };
          this.supplierService.CreateBusinessEntities(`${this.Config.ApiSupplierUrl}business-entities`, datas).subscribe(data2 => {
            tempBusinessRowId = data2['row_id'];
            this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityId=${tempBusinessRowId}&_page=1`).subscribe(data1 => {
              if (data1['pageCount'] > 0) {

              }
              else {
                const const2 = {
                  "businessEntityIdentifierTypeId": "1",
                  "businessEntityIdentifierTypeName": "BVD ID",
                  "startDate": this.apiService.getTodayDate(),
                  "businessEntityId": tempBusinessRowId,
                  "value": BvDidforsite
                }
                this.supplierService.CreateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers`, const2).subscribe(_data2 => {});
              }
              const const3 = {
                "validityStartDate": this.apiService.getTodayDate(),
                "status": "VALIDATED",
                "businessEntityId": tempBusinessRowId
              }
              this.groupCurrentStatus = 'Creating Site Assignment';
              this.nextBtnNotVisible = true;
              console.info("CNSVAlue", fromCnS);
              this.supplierService.CreateSiteAssignments(`${this.Config.ApiSupplierUrl}site-assignments?site=SupSiteService:${siteID}`, const3).subscribe(data3 => {
                this.businessEntityIdSite = data3.businessEntityId;
                this.addTaxIdentifiers(BvDidforsite, siteID, thisBvDdata);
                this.changeParamsforNewCpy('doesnotexist', siteID, CMPiD, Site_Name, BvDidforsite, fromCnS);
              });
            });
          });
        }
      });
    }
  }

  changeParamsforNewCpy(_con, site_id, CompanayID, Site_Name, BvDidforsite, fromCnS = "N") { //if con is 'exist' site assn exist else site assn do not exist fn....
    this.cpyAlcorToRaft = [];
    this.groupCurrentStatus = 'Creating Raft Account';
    this.nextBtnNotVisible = true;
    if (CompanayID != '' && CompanayID != undefined) {
      this.supplierService.getCompanies(`${this.Config.ApiSupplierUrl}companies/${CompanayID}`).subscribe(data1 => {

        const const1 = { "name": Site_Name, "activeStatus": "CREATED"  }
        this.siteService.updateSite(`${this.Config.ApiSitesUrl}sites/${site_id}`, const1).subscribe(_data0 => {

        });
        // const constSiteStatus = {}
        // this.siteService.updateSite(`${this.Config.ApiSitesUrl}sites/${site_id}`, constSiteStatus).subscribe(_data1 => {
        // });
        let shortName;
        this.supplierService.getCompanyNames(`${this.Config.ApiSupplierUrl}company-names?companyId=${CompanayID}`).subscribe(data2 => {
          if (data2['company-names'].length > 0) {
            shortName = data2['company-names'][0]['value'];
          } else {
            shortName = data1['legalName'].slice(0, TEN);
          }
          this.cmpShortName=shortName

          this.siteService.getRealEstateAssetIdentifiers(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers?realEstateAssetId=${site_id}&identifierType=RAFT_ACCOUNT`).subscribe(data6 => {
            if (data6['real-estate-asset-identifiers'].length > 0) {
              const constEndDate = { "endDate": this.apiService.getTodayDate() }
              data6['real-estate-asset-identifiers'].forEach(ele => {
                this.cpyAlcorToRaft.push(ele.businessIdentifierValue);
                this.arrBasedOnVal[ele.businessIdentifierValue] = ele.rowId;
                this.siteService.updateRealEstateAssetIdentifier(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers/${ele.rowId}`, constEndDate).subscribe(_data7 => {
                });
              });
            }
            this.supplierService.getCompanyIdentifiers(`${this.Config.ApiSupplierUrl}company-identifiers?linkedCompanyId=${CompanayID}&companyIdentifierKeyName=ALCOR`).subscribe(data8 => {
              if (data8['company-identifiers'].length > 0) {
                let const5;
                if (shortName == '') {
                  shortName = data1['legalName'].slice(0, TEN);
                }
                this.cmpShortName=shortName
                const constNoEndDate = { "endDate": "" }
                data8['company-identifiers'].forEach(elem => {

                  if (this.cpyAlcorToRaft.indexOf(elem.value) == -1) { //replace all alcor of new cpy as raft account of site..
                    this.siteService.getIdentifierTypes(`${this.Config.ApiSitesUrl}identifier-types?name=RAFT_ACCOUNT`).subscribe(data1 => {
                    if (elem.endDate == '') {
                      const5 = {
                        "businessIdentifierId": data1['identifier-types'][0]['rowId'],
                        "sourceSystemId": "2",
                        "businessIdentifierValue": elem.value,
                        "effectiveDate": this.apiService.getTodayDate(),
                        "businessIdentifierName": shortName,
                        "realEstateAssetId": site_id
                      }
                    } else {
                      const5 = {
                        "businessIdentifierId": data1['identifier-types'][0]['rowId'],
                        "sourceSystemId": "2",
                        "businessIdentifierValue": elem.value,
                        "effectiveDate": this.apiService.getTodayDate(),
                        "businessIdentifierName": shortName,
                        "realEstateAssetId": site_id,
                        "endDate": elem.endDate
                      }
                    }

                    this.siteService.createRealEstateAssetIdentifier(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers`, const5).subscribe(_data9 => {
                    })
                  })
                  } else {
                    if (this.arrBasedOnVal[elem.value]) {
                      this.siteService.updateRealEstateAssetIdentifier(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers/${this.arrBasedOnVal[elem.value]}`, constNoEndDate).subscribe(_data10 => {

                      });
                    }
                  }
                });
              }
              this.changeAccessPointsToPending(site_id, CompanayID, BvDidforsite);
              console.info("**** Create Site Done ****", fromCnS);
              if (fromCnS == "Y") {
                this.fetchCompanyDetails(BvDidforsite);
                this.groupCurrentStatus = 'Fetching Company Details';
              } else if (fromCnS == "S") {
                this.fetchSiteDetails();
                this.groupCurrentStatus = 'Fetching Site Details';
              } else if (fromCnS == 'W') {
                this.getBvdinterfaceSite(BvDidforsite);
                this.fetchSiteDetails();
                this.groupCurrentStatus = 'Fetching Site Details';
              } else {
                this.fetchGroupDetails(BvDidforsite, "Hide");
                this.groupCurrentStatus = 'Fetching Group Details';
              }

            });
          });


          this.siteService.getRealEstateAssetIdentifiers(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers?realEstateAssetId=${site_id}&identifierType=SHORT_NAME`).subscribe(data3 => {
            if (data3['real-estate-asset-identifiers'].length > 0) { // if there is existing value edit that value..
              let tempShtNameRowId = data3['real-estate-asset-identifiers'][0]['rowId'];

              const const11 = { 'endDate': this.apiService.getTodayDate() }
              this.siteService.updateRealEstateAssetIdentifier(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers/${tempShtNameRowId}`, const11).subscribe(_data4 => {

              });
            } else { 
            }
          });

        });
        this.changeRealEstateAssignments(site_id, data1['legalName']); //update real estate assignments...
      });

    }
  }

  changeRealEstateAssignments(site_id, CompNme) {
    this.groupCurrentStatus = 'Update Real Esatate Assignments';
    this.siteService.getRealEstateAssetAssignments(`${this.Config.ApiSitesUrl}real-estate-asset-assignments?realEstateAssetId=${site_id}`).subscribe(data => {
      if (data['real-estate-asset-assignments'].length > 0) {
        let exist: any = false;
        let rowId = '';
        const const1 = { categoryId: this.newCategoryAssignment, categoryName: this.newCategoryName };
        const constEndDate = { "endDate": this.apiService.getTodayDate() };
        let c = 0;
        data['real-estate-asset-assignments'].forEach((element, _index) => {


          if ((element.categoryCode != '') && exist == false && element.legalEntityIdentifier == '') {
            rowId = element.rowId;
            exist = true;
          }
          if (element.legalEntityIdentifier != '' && element.endDate != '') {
            this.siteService.updateRealEstateAssetAssignment(`${this.Config.ApiSitesUrl}real-estate-asset-assignments/${element.rowId}`, constEndDate).subscribe(_data1 => {

            });
          }
          c++;
        });
        if (exist == false) {
          this.siteService.updateRealEstateAssetAssignment(`${this.Config.ApiSitesUrl}real-estate-asset-assignments/${rowId}`, const1).subscribe(_data => {
          });
        }
      }
    });

    const newLegalEntity = { "corporateName": CompNme, "active": '1' }
    this.groupCurrentStatus = 'Creating Legal Entity';
    this.nextBtnNotVisible = true;
    this.siteService.getRealEstateAssetAssignments(`${this.Config.ApiSitesUrl}real-estate-asset-assignments?corporateName=${CompNme}&realEstateAssetId=${site_id}`).subscribe(data014 => {
      let tempRow = '';
      let runLegal = true;
      if (data014['real-estate-asset-assignments'].length > 0) {
        const endDateSet = { endDate: this.apiService.getTodayDate() };
        const noEndD = { endDate: '' }
        for (let i = 0; i < data014['real-estate-asset-assignments'].length; i++) {
          if (data014['real-estate-asset-assignments'][i]['legalEntityIdentifier'] != '' && data014['real-estate-asset-assignments'][i]['endDate'] == '' && data014['real-estate-asset-assignments'][i]['legalEntityCorporateName'] != CompNme) {
            this.siteService.updateRealEstateAssetAssignment(`${this.Config.ApiSitesUrl}real-estate-asset-assignments/${data014['real-estate-asset-assignments'][i]['rowId']}`, endDateSet).subscribe(_data0 => {

            });
          }
          if (data014['real-estate-asset-assignments'][i]['legalEntityCorporateName'] == CompNme) {
            tempRow = data014['real-estate-asset-assignments'][i]['legalEntityId'];
            runLegal = false;
            if (data014['real-estate-asset-assignments'][i]['endDate'] != '') {
              this.siteService.updateRealEstateAssetAssignment(`${this.Config.ApiSitesUrl}real-estate-asset-assignments/${data014['real-estate-asset-assignments'][i]['rowId']}`, noEndD).subscribe(_data0 => {
              });
            }

          }
        }
      }
      if (runLegal == true) {
        this.siteService.createLegalEntity(`${this.Config.ApiSitesUrl}legal-entities`, newLegalEntity).subscribe(data013 => {
          const newLegalPost = { 'realEstateAssetId': site_id, 'legalEntityId': data013['rowId'] }
          this.siteService.createRealEstateAssetAssignment(`${this.Config.ApiSitesUrl}real-estate-asset-assignments`, newLegalPost).subscribe(_data015 => {

          });
        });
      }
    });
  }

  changeAccessPointsToPending(site_id, _CompanayID, _BvDidforsite) {
    this.groupCurrentStatus = 'Changing Access Point status';
    this.siteService.getAccessPoints(`${this.Config.ApiSitesUrl}access-points?realEstateAssetId=in(${site_id})&_page=1`).subscribe(data => {
      var sitesData = data['access-points'];
      if (sitesData.length > 0) {
        const constPending = { "activeStatus": "PENDING" }
        const constActive = { "activeStatus": "ACTIVE" }
        const constEndDate = { "endDate": this.apiService.getTodayDate() }
        let OrderManuInvoi = ['P05', 'P06', 'P11'];
        data['access-points'].forEach(element => {

          if (this.qualifierChangetoPending.indexOf(element.type) != -1) {
            if (element.activeStatus != 'PENDING') {
              if (element.activeStatus == 'ARCHIVED') {
                this.siteService.updateAccessPoint(`${this.Config.ApiSitesUrl}access-points/${element.rowId}`, constActive).subscribe(_data0 => {
                  this.siteService.updateAccessPoint(`${this.Config.ApiSitesUrl}access-points/${element.rowId}`, constPending).subscribe(_data11 => {
                  });
                });
              } else {
                this.siteService.updateAccessPoint(`${this.Config.ApiSitesUrl}access-points/${element.rowId}`, constPending).subscribe(_data1 => {

                });
              }
            }

            if (OrderManuInvoi.indexOf(element.type) != -1 && element.identifier) {
              this.siteService.getAccessPointIdentifiers(`${this.Config.ApiSitesUrl}access-point-identifiers?accessPointIdentifier=${element.identifier}`).subscribe(getdata12 => {
                if(getdata12["access-point-identifiers"].length>0){
                if(getdata12["access-point-identifiers"][0].identifierTypeName!='AP_C2B_CODE'){
                this.siteService.updateAccessPointIdentifier(`${this.Config.ApiSitesUrl}access-point-identifiers/${getdata12["access-point-identifiers"][0].rowId}`, constEndDate).subscribe(_data12 => {
                });
              }
              }
              })

            }
          }
        });
      }
    });

  }

  checkvalidateGroupShortNameField(event) {
    this.groupShortName = event.toUpperCase();
    let regEx = new RegExp('^[a-zA-Z0-9]+$');
    if (this.groupShortName.trim() == '') {
      this.groupShortNameError = true;
      this.groupShortNameRegExError = false;
    } else {
      if (regEx.test(this.groupShortName)) {
        this.groupShortNameRegExError = false;
      } else {
        this.groupShortNameRegExError = true;
      }
      this.groupShortNameError = false;
    }
  }
  updateCreateGroupExistsName() {
    this.groupNameModel = '';
    this.groupCategoryModel = '';
    this.groupCommodityCodeModel = '';
    this.groupShortName = '';
    this.groupNameModelError = false;
    this.groupShortNameError = false;
    this.groupShortNameRegExError = false;
    this.groupShortNameExistsError = false;
    this.groupCategoryModelError = false;
  }
  addTaxIdentifiers(sitebvidid, site_id, thisBvDdatatoImport) {
    if (sitebvidid != '') {
      let thisBvDdata = [];
      const bvdConst = { 'bvd-id': sitebvidid, import : "Y" }
        let bVdDatas = thisBvDdatatoImport
        if (bVdDatas != undefined && bVdDatas != null) {
          thisBvDdata = bVdDatas;
          this.currentOrbisStatus=bVdDatas['STATUS'][0]
        }
        console.info('thisbvdData', thisBvDdata);
        console.info('bVdDatas', bVdDatas);
        this.getTaxIdentifiers(site_id);
        let variable = [];
        if (thisBvDdata != undefined) {
          if (bVdDatas['NATIONAL_ID_LABEL'] != null) {
            console.info("bVdDatas['NATIONAL_ID_LABEL']", bVdDatas['NATIONAL_ID_LABEL'])
            if (typeof bVdDatas['NATIONAL_ID_LABEL'] != "string") {
              variable = bVdDatas['NATIONAL_ID_LABEL'].filter(d1 => { return d1 != null });
              bVdDatas['NATIONAL_ID_LABEL'] = variable;
            }
            if (bVdDatas['NATIONAL_ID_LABEL'].length > 0 && bVdDatas['NATIONAL_ID_LABEL'] != null) {
              console.info('yes');
              let nationalIdLabel = [];
              let nationalId = [];
              nationalIdLabel = bVdDatas['NATIONAL_ID_LABEL'];
              nationalId = bVdDatas['NATIONAL_ID'];

              this.manageNewBeIdentifiers(nationalIdLabel, nationalId);
            } else {
              this.newOrbisStatus()
              console.info('%c no tax identifiers', "color : #cb4b32;font-weight:bold")
            }
          } else {
            this.newOrbisStatus()
            console.info('%c no tax identifiers', "color : #cb4b32;font-weight:bold")
          }
        } else {
          this.deleteAllBusinesIdens();
          console.info('%c no tax identifiers', "color : #cb4b32;font-weight:bold")
        }
        console.info("BvDdata", thisBvDdata);
    }
  }

  deleteAllBusinesIdens() {
    this.TaxIdentifierKeys.forEach(e => {
      if (this.companyAliasAll[e]) {
        this.companyAliasAll[e].forEach(ele => {
          this.supplierService.deleteBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers/${ele.key}`).subscribe(_data => {

          });
        });
      }
    });
  }

  getCompanyIdentifierTypes(page = 1, subscribeData = []) {
    this.supplierService.getBuinessEntityIdentifierTypes(`${this.Config.ApiSupplierUrl}business-entity-identifier-types?_page=${page}`).subscribe((data: any) => {
      this.TaxIdentifierKeys = [];
      data['business-entity-identifier-types'].forEach(element => {
        subscribeData.push(element);
      });
      if (data['maxPage'] > 1 && data['maxPage'] != page) {
        this.getCompanyIdentifierTypes(page + 1, subscribeData);
      } else if (data['maxPage'] == page) {
        subscribeData.forEach(element => {
          this.TaxIdentifierKeys.push(element.name);
        });
      }
    });
  }

  getTaxIdentifiers(site_id, bvdf = '') {
    this.supplierService.getSiteAssignments(`${this.Config.ApiSupplierUrl}site-assignments?site=SupSiteService:${site_id}&_page=1&status=VALIDATED`).subscribe(data1 => {
      var c = '';
      let count = 0;
      if (data1['pageCount'] == 1) {
        if (data1['site-assignments'][0]['status'] == 'VALIDATED') {
          data1['site-assignments'].forEach(element => {
            if (count == 0) {
              c = element.validityStartDate;
            }
            count++;
            if (c != '' && count > 0) {
              if (c < element.validityStartDate) {
                c = element.validityStartDate
              }
            }
            if (c == element.validityStartDate) {
              bvdf = element.businessEntityId;
              this.businessEntityIdSite = element.businessEntityId;
            }
          });
        }
      }
    });
    this.companyAliasAll = [];
    this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityId=${bvdf}`).subscribe(data => {
      if (data['business-entity-identifiers'].length > 0) {
        data['business-entity-identifiers'].forEach((e, _index) => {
          if (e.endDate == "" && e.businessEntityIdentifierTypeName != 'BVD ID') {
            let temps = {};
            if (!this.companyAliasAll[e.businessEntityIdentifierTypeName]) {
              this.companyAliasAll[e.businessEntityIdentifierTypeName] = [];
            }
            temps = { 'val': e.value, 'key': e.row_id, 'endDate': e.endDate }
            this.companyAliasAll[e.businessEntityIdentifierTypeName].push(temps);
          }
        });
      }
      this.getCompanyIdentifierTypes();
    });
  }
 
 
  newOrbisStatus(){
    this.supplierService.getBuinessEntityIdentifierTypes(`${this.Config.ApiSupplierUrl}business-entity-identifier-types?name=ORBIS-STATUS`).subscribe((dataId: any) => {
      console.info(dataId['business-entity-identifier-types'][0]['row_id'],);
    const const2 = {
          "businessEntityIdentifierTypeId"    : dataId['business-entity-identifier-types'][0]['row_id'],
          "businessEntityIdentifierTypeName"  : 'ORBIS-STATUS',
          "startDate"                         : this.apiService.getTodayDate(),
          "businessEntityId"                  : this.businessEntityIdSite,
          "value"                             : this.currentOrbisStatus
    }
    this.supplierService.CreateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers`,const2).subscribe(_data=>{})
  })
  }


  manageNewBeIdentifiers(nationalIdLabel, nationalId, allKeyNames = [], allNAKeyNames = [], subscribeData = [], page = 1) {
    this.supplierService.getBuinessEntityIdentifierTypes(`${this.Config.ApiSupplierUrl}business-entity-identifier-types?_page=${page}`).subscribe((data: any) => {
      if (data['business-entity-identifier-types'].length > 0) {
        data['business-entity-identifier-types'].forEach(element => {
          subscribeData.push(element);
          allKeyNames.push(element['name'].toLowerCase())
        });
        if (data['maxPage'] > 1 && data['maxPage'] != page) {
          this.manageNewBeIdentifiers(nationalIdLabel, nationalId, allKeyNames, allNAKeyNames, subscribeData, page + 1);
        } else if (data['maxPage'] == page) {
          subscribeData.forEach(element => {
            this.companyIdenKeys[element['name'].toLowerCase()] = element['row_id'];
          });
          nationalIdLabel.forEach(e => {
            if (allKeyNames.indexOf(e.toLowerCase()) == -1) {
              allNAKeyNames.push(e);
            }
          });
          if (allNAKeyNames.length > 0) {
            this.createNewIdentifiers(allNAKeyNames, nationalIdLabel, nationalId);
          } else {
            this.deletePreviousIdentifiers2(nationalIdLabel, nationalId);
          }
        }
      }
    });
  }

  createNewIdentifiers(allNAKeyNames, nationalIdLabel, nationalId) {
    console.info('allNAKeyNames', allNAKeyNames);
    allNAKeyNames.forEach((e, index) => {
      const createIden = { 'name': e, 'type': 'TAXATION' }
      this.supplierService.createBuinessEntityIdentifierTypes(`${this.Config.ApiSupplierUrl}business-entity-identifier-types`, createIden).subscribe(_data => {
        if (index + 1 == allNAKeyNames.length) {
          this.manageNewBeIdentifiers(nationalIdLabel, nationalId);
        }
      });
    });
  }

  deletePreviousIdentifiers2(nationalIdLabel, nationalId, subscribeData = [], delBvdIds = [], page = 1) {
    this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityId=in(${this.businessEntityIdSite})&_page=${page}`).subscribe(data => {
      if (data['business-entity-identifiers'].length > 0) {
        data['business-entity-identifiers'].forEach(e => {
          if (e.businessEntityIdentifierTypeName != 'BVD ID') {
            delBvdIds.push(e.row_id);
          }
        });
      }
      if (data['maxPage'] > 1 && data['maxPage'] != page) {
        this.deletePreviousIdentifiers2(nationalIdLabel, nationalId, subscribeData, delBvdIds, page + 1);
      } else if (data['maxPage'] == page) {
        if (delBvdIds.length > 0) {
          delBvdIds.forEach((e, index) => {
            this.supplierService.deleteBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers/${e}`).subscribe(_data => {
              if (index + 1 == delBvdIds.length) {
                this.postNewBeIdentifiers(nationalIdLabel, nationalId);
              }
            });
          });
        } else {
          this.postNewBeIdentifiers(nationalIdLabel, nationalId);
        }
      }
    });
  }

  postNewBeIdentifiers(nationalIdLabel, nationalId) {
    for (let i = 0; i < nationalIdLabel.length; i++) {
      if(nationalId[i]!=null){
      const const2 = {
        "businessEntityIdentifierTypeId": this.companyIdenKeys[nationalIdLabel[i].toLowerCase()],
        "businessEntityIdentifierTypeName": nationalIdLabel[i],
        "startDate": this.apiService.getTodayDate(),
        "businessEntityId": this.businessEntityIdSite,
        "value": nationalId[i]
      }
      this.supplierService.CreateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers`, const2).subscribe(_data => {
        if (i + 1 == nationalIdLabel.length) {
          this.companyAliasAll = [];
        }
      }, error => {
        // Handle duplicate identifier error gracefully (400 - functional key already exists)
        if (error && error.status === HTTP_STATUS_BAD_REQUEST) {
          console.info("[INFO] Identifier already exists, skipping:", nationalIdLabel[i], nationalId[i]);
        } else {
          console.error("[ERROR] Failed to create business entity identifier:", error);
        }
        if (i + 1 == nationalIdLabel.length) {
          this.companyAliasAll = [];
        }
      });
    }
      if(i==(nationalIdLabel.length-1)){
        this.newOrbisStatus();
      }

    }
  }
  checkvalidatec2b(event):Observable<string>{
      this.c2bName= event.toUpperCase();
      let valueLength=this.c2bName.length
      if(valueLength>=FOUR && valueLength<=TEN){
        const regex = /^[A-Z]{3}[0-9]{1,7}$/;
        if(regex.test(this.c2bName)){
          if(this.c2bName.slice(0,THREE)=='SUP'){
            return this.siteService.getAccessPointIdentifiers(`${this.Config.ApiSitesUrl}access-point-identifiers?identifierTypeName=AP_C2B_CODE&identifierValue=${this.c2bName}`)
              .pipe(map((data) => 
                data['access-point-identifiers'].length > 0 ? 'C2B code is not unique' : 'valid'
              ))
          }else{
            return of('C2B code is not valid')
          }
        }else{
          return of('C2B code is not valid')
        }
      }else{
        return of('C2B code is not valid')
      }
    }
  nullify(message){
    if(JSON.parse(localStorage.getItem('tempBvdIdInFileForLocal'))!=null){
    const hasRetriableServerError = RETRIABLE_SERVER_ERROR_PATTERN.test(message || '');
    this.groupLinkError = message ||' A general failure occurred unexpectedly, and the import cannot continue right now.Please have a retry later'
    if (hasRetriableServerError) {
      this.Error502 = true
      this.checkConditionAndNotify2()
    }
    }
  }    
}
